import { Component, HostListener, OnInit, Pipe, PipeTransform, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { AvailabilityCriteria, BookingBehavior, NoteType, PartyState, AttributeType, LocationViewTypes, ComponentTypes, ActivityBookings, ScreenType, DEFAULT_LANGUAGE_CODE , BookingGuestType, Status } from 'src/app/shared/constants/commonenums';
import {
  ActivitySlotRequestDTO, AvailabilityType,
  ClassType, SessionBookingDTO
} from 'src/app/shared/Models/SessionBookingDTO';
import { GuestService } from 'src/app/shared/services/guest.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import moment from 'moment';
import { SpecialMealDTO, operationType } from 'src/app/shared/Models/WidgetSettingsModels';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactAddressDTO, FullContactDTO, PartyNoteType, SessionAvailabiltyStatus ,BookingTypeInfo} from 'src/app/shared/Models/PartyModels';
import { MatChip } from '@angular/material/chips';
import _ from 'lodash';
import { ActivitiesLiteGuestDataComponent } from '../activities-lite-guest-data/activities-lite-guest-data.component'
import { FormControl, Validators } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { ReservationService } from 'src/app/layout/reservation.service';
import { HttpService } from 'src/app/shared/services/http.service';
import { urlConfig } from 'src/app/shared/constants/url-config';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { ValidationMessageType } from 'src/app/shared/Models/ResultModels';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivitiesLayoutSupportService } from '../activities-layout/activities-layout-support.component';


@Component({
  selector: 'app-activity-session-selection',
  templateUrl: './activity-session-selection.component.html',
  styleUrls: ['./activity-session-selection.component.scss', './../activities-lite.component.scss'],
 encapsulation:ViewEncapsulation.None
})

export class ActivitySessionSelectionComponent extends Utilities implements OnInit {

  @ViewChild('commentDetailsForm') commentDetailsForm;
  @ViewChild(ActivitiesLiteGuestDataComponent, { static: true }) activitiesLiteGuestDataComponent: ActivitiesLiteGuestDataComponent;
  subscriptions: Subscription = new Subscription();
  checkedItem = false;
  sessionSlotsAvailableDates: any = null;
  showSessionorSlots = false;
  selectedIndex = 0;
  isSessionClass: any;
  availableSessions: any[];
  classLessonList: any[];
  selectedClassSchedule: any = [];
  selectedActivityData: any;
  validGroupSize = false;
  coverTypes = [];
  activityHeadlines = [];
  bookingTypes = [];
  validBookingTypes = true;
  instructorList: any[];
  locationList: any[];
  bookingSizeArray: any = [];
  classDetail: any;
  minSizeAllowed = 1;
  maxSizeAllowed = 10;
  currentInstructors: any;
  currentLocations: any;
  currentFromDate: any;
  currentToDate: any;
  currentBookingSize = 0;
  bookAllAvailableDates = false;
  isMultiSlotSelection = false;
  isEdit = false;
  venueAllocationMappings: any;
  overAllBookingSize = 0;
  lockResponse: any;
  freeTextIdList = [];
  notesOptions = [];
  noteType: number;
  seatingAreaMasterList = [];
  seatingArea = [];
  selectedSeatingArea = 0;
  seatingTypesMasterList = [];
  seatingType = [];
  selectedSeatingType = 0;
  seatingAreaSeatingTypeMappings = [];
  daysForReservation = 0;
  diningMaxDate: Date;
  propertyMaxDateAllowed: Date;
  showParticularDays: any;
  availableSpecialMeals = [];
  isCommunalTable = false;
  showSpecialEvent = true;
  isTimeDropList = false;
  selectedDiningSlots = [];
  checkedDiningLocalTime = '';
  sessionsUnavailable: any[];
  selectedTimeSlots: any = [];
  ratePlan: any;
  originalTimeSlotList = [];
  otherAvailableDays = [];
  showAvailableDates = true;
  promoCodeDetail = '';
  marketingFlag = false;
  customGuestFields: any = [];
  // showGuestFields:boolean = false;
  guestContact: any;
  editContactData: any = {};
  guestContactValidation: boolean = false;
  selectedMealAddOns: any;
  openHourDays = [];
  CustomOpenHours = [];
  nonDiningMaxDate: Date;
  selectedNonDiningSlots: any[] = [];
  checkedNonDiningLocalTime: string = '';
  matchedContinousSlots: any[] = [];
  bShowLocation: boolean = false;
  tableList: any[] = [];
  filteredTableList: any[] = [];
  // selectedNonDiningLocation: any;
  selectedNonDiningSlotsDisplayText: string;
  TimeSlotUnitInMinutes: number = 10;
  durationControl = new FormControl('');
  durationList: any[] = [];
  filteredDurationOptions: Observable<any[]>;
  bIsSlotReloadRequired: boolean = false;
  showNextArrow = false;
  floorPlan;
  updateIndicator;
  mealWithConfig: any;
  // locationView: 'list' | 'map' = 'list';
  locationViewTypes = LocationViewTypes;
  @ViewChild('slotEditngbPopOver') public slotEditngbPopOver: NgbPopover;
  @ViewChild('coverAndBookingTypeEditngPopOver') public coverAndBookingTypeEditngPopOver: NgbPopover;
  bUpdateNonDiningBackUpData: boolean = true;
  nonDiningBackUpData: any;
  locationMappedSeatingTypes: Number[] = [];
  finishReservationClicked: boolean = false;
  secondaryContacts: any[] = [];
  selectedBookingType:number;
  bookingTypeList:any[] = [];
  BookingGuestType = BookingGuestType;
  confirmationNumber:string;
  bookingTypePlaceholder: string;
  bookingTypeMinDate : Date;
  bookingTypeMaxDate : Date;
  disableDatePicker : boolean = false;
  sizeMapping:any;
  getSlotInitial: boolean = false;
  addToCartEnableForTaxType: boolean = true;
  seatingTypeNames: {
    [key: string]: string
  } = {}
  constructor(
    private httpService: HttpService,
    private ts: TranslateService,
    public activityService: GuestService,
    private router: Router,
    public route: ActivatedRoute, private rs: ReservationService,
    private dfs: DynamicFormService,public dialog: MatDialog,  public rateplanSupportService: ActivitiesLayoutSupportService) {
      super(dialog);
  }

  // viewChange(){
  //   if(this.locationView === 'list'){
  //     this.locationView = 'map';
  //   }else{
  //     this.locationView = 'list';
  //   }
  // }

  ngOnInit(): void {
   // this.activityService.resetConfigBasedStyles();
    this.activityService.stopTimer();
    this.activityService.showBackNav();
    this.activityService.currentNavURL = 'session-selection';
    this.activityService.prevNavURL = 'list';
    let widgetCustomization =null;
    if(this.activityService.widgetSettings && this.activityService.widgetSettings.PropertyWidgetSettings){
    widgetCustomization = this.activityService.widgetSettings.PropertyWidgetSettings.find(property => property.RestaurantId == this.activityService.restaurantWidgetId)?.WidgetCustomization;
    if(widgetCustomization) {
    this.showSpecialEvent = widgetCustomization.DefaultReservationView ? false : true;
    }
  }
    this.activityService.restaurantMerchantCode = this.route.snapshot.params.merchantId;
    let cartList = JSON.parse(sessionStorage.getItem('CartList_' + this.activityService.restaurantMerchantCode));
    if(cartList?.length && this.activityService.widgetSettings && this.activityService.widgetSettings.PropertyWidgetSettings){
      this.addToCartEnableForTaxType = this.activityService.widgetSettings.PropertyWidgetSettings.find((property) => property.RestaurantId == cartList[0].PropertyId).TaxType == this.activityService.widgetSettings.PropertyWidgetSettings.find((property) => property.RestaurantId == this.route.snapshot.params.restaurantId)?.TaxType
    }
    if (this.activityService.isNonDining) {
      if (this.route.snapshot.queryParams.activityId) {
        let activity = this.activityService.allClassActivitiesAvailable$?.value && this.activityService.allClassActivitiesAvailable$.value.find(({ Id }) => Id === +this.route.snapshot.queryParams.activityId);
        if (activity) {
          this.backToSlotSelect();
          this.setActivityData(activity);
        } else {
          this.activityService.activityIdFromURL = +this.route.snapshot.queryParams.activityId;
          this.activityService.navigateToUrl(`list`, null, "/" + this.activityService.activityIdFromURL);
          return;
        }
      } else if (this.route.snapshot.queryParams.bookaspot) { 
        let _restaurantData = this.activityService.widgetSettings?.PropertyWidgetSettings && this.activityService.widgetSettings.PropertyWidgetSettings.find((property) => property.RestaurantId === +this.route.snapshot.params.restaurantId && property.AcceptsReservations && property.WidgetCustomization.ActivityBookings.filter(y => y == ActivityBookings.OpenBooking)?.length);
        if (_restaurantData) {
          this.activityService.clickReserveNow_NonDining(_restaurantData);
        } else {
          this.activityService.navigateToUrl(`list`, { propertyId: +this.route.snapshot.params.restaurantId });
          return;
        }
      } else {
        this.activityService.navigateToUrl(`list`);
        return;
      }
    }

    this.activityService.getCartCount();
    this.isEdit = this.activityService.operation === operationType.edit ? true : false;
    this.activityService.hideCart.next(this.isEdit);
    if(this.activityService?.sessionFilterValue?.isSpecialMealReservation) {
      this.showSpecialEvent = this.activityService?.sessionFilterValue?.isSpecialMealReservation;
    }
    else if(this.activityService.isSpecialMeal) {
      this.showSpecialEvent = this.activityService?.isSpecialMeal;
    }
    else {
      this.showSpecialEvent = widgetCustomization?.DefaultReservationView ? false : true;
    }
    this.setLockCartData();
  }

  setLockCartData(){
    if (this.activityService.cartCount > 0) {
      let modifiedLockCart = [];
      const CartLockList = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true) || [];
      CartLockList.forEach(cartlock => {
        if (cartlock.slotLockResp) {
          modifiedLockCart.push(cartlock.slotLockResp);
        }
      });
      if (modifiedLockCart?.length && modifiedLockCart.length) {
        this.unLockMultiCart(CartLockList, modifiedLockCart);
      } else {
        this.checkDataPresent();
      }
    } else {
      this.checkDataPresent();
    }
  }

  ngAfterViewInit() {
    if(!this.isEdit){
      this.setBookingType();
    }
  }
  
  setBookingType(){
    let _restaurantData = this.activityService.widgetSettings.PropertyWidgetSettings?.find((property) => property.RestaurantId === this.activityService.restaurantWidgetId);
    this.bookingTypeList = [];
    if (_restaurantData) {
      let bookingTypeForActivity = _restaurantData.AvailableSpecialMeals.find(meal => meal.Id == this.selectedActivityData?.SpecialMealId)
      let bookingTypes  = this.selectedActivityData?.SpecialMealId ? bookingTypeForActivity?.BookingTypeActivitiesMappings : _restaurantData?.BookingTypes;
      if(bookingTypes?.length){
    this.getMemberConfig(bookingTypes);
     }
    }
  }
  getMemberConfig(bookingTypes) {
    bookingTypes = bookingTypes?.filter(bookingType => bookingType.BookingGuestType);
    let defaultValue = bookingTypes?.find(bookingType => bookingType.IsDefault)?.BookingGuestType || BookingGuestType.Others;
    let options = [];
    if (bookingTypes?.length) {
      bookingTypes.forEach(bookingType => {
        options.push({ id: bookingType.BookingGuestType, value: bookingType.Name });
      })
    }
    this.bookingTypeList = options;
    this.selectedBookingType = this.isEdit ? this.activityService.editData?.BookingTypeInfo?.BookingGuestTypes : defaultValue;
    this.confirmationNumber = this.isEdit ? this.activityService.editData?.BookingTypeInfo?.Input : '';
    this.bookingTypePlaceholder =  this.selectedBookingType === BookingGuestType.HotelGuest ? this.ts.instant ('Confirmation') : this.ts.instant('Membership');
    if((BookingGuestType.Others == defaultValue || this.confirmationNumber) && this.bookingTypeList?.length){
      this.applyBookingType(true);
    }
  }
  applyBookingType(skipWarnings?: boolean) {
    this.activityService.byPassValidation = false;
    this.subscriptions.add(this.rs.getBookingTypesDetails(this.route.snapshot.params.restaurantId, this.confirmationNumber || null, this.selectedBookingType, this.selectedActivityData?.SpecialMealId).subscribe(response => {
      if (response) {
        if (new Date(response.BookingRange.Start).getFullYear() < new Date().getFullYear() || new Date(response.BookingRange.End).getFullYear() < new Date().getFullYear() ) {
          if (response.HotelGuestRange) {
            this.disableDatePicker = false;
            this.bookingTypeMinDate = new Date(response.HotelGuestRange.Start);
            this.bookingTypeMaxDate = new Date(response.HotelGuestRange.End);
            if (!skipWarnings) this.activityService.openSnackBar(this.ts.instant('memberVerificationMsg'), 'CLOSE', 3000, 'large-size-snack');
          } else {
            this.disableDatePicker = true;
            if (!skipWarnings) this.activityService.openSnackBar(this.ts.instant('memberVerificationMsg'), 'CLOSE', 3000, 'large-size-snack');
          }
        } else if (response.HotelGuestRange) {
          this.setHotelDateRange(response, skipWarnings);
        } else {
          this.disableDatePicker = false;
          this.bookingTypeMinDate = new Date(response.BookingRange.Start);
          this.bookingTypeMaxDate = new Date(response.BookingRange.End);
          if (!skipWarnings) this.activityService.openSnackBar(this.ts.instant('memberVerificationMsg'), 'CLOSE', 3000, 'large-size-snack');
        }
        if(!moment(this.currentFromDate).isBetween(this.bookingTypeMinDate , this.bookingTypeMaxDate)){
          this.currentFromDate = this.bookingTypeMinDate;
        }
        this.changeFromDate();
        this.checkSessionorSlotAvailability(false , true);
      }
    }));
  }

  setHotelDateRange(response, skipWarnings) {
    let bookingStart = new Date(moment(response.BookingRange.Start).format('YYYY-MM-DD') + 'T00:00:00');
    let bookingEnd = new Date(moment(response.BookingRange.End).format('YYYY-MM-DD') + 'T00:00:00');
    if (Utilities.datetimeBetween(bookingStart, bookingEnd, response.HotelGuestRange.Start) || Utilities.datetimeBetween(bookingStart, bookingEnd, response.HotelGuestRange.End)) {

      this.disableDatePicker = false;
      this.bookingTypeMinDate = new Date(response.HotelGuestRange.Start) >= new Date(bookingStart) ? new Date(response.HotelGuestRange.Start) : new Date(bookingStart);
      this.bookingTypeMaxDate = new Date(response.HotelGuestRange.End) > new Date(bookingEnd) ? new Date(bookingEnd) : new Date(response.HotelGuestRange.End);
      if (!skipWarnings) this.activityService.openSnackBar(this.ts.instant('memberVerificationMsg'), 'CLOSE', 3000, 'large-size-snack');
    } else {
      this.disableDatePicker = true;
      this.activityService.openSnackBar(this.ts.instant('stayDateWarningMessage'), 'CLOSE', 3000, 'large-size-snack');
    }
  }

  bookingTypeChangeHandler(){
  this.selectedBookingType;
  this.confirmationNumber = '',
  this.disableDatePicker = false;
  this.bookingTypePlaceholder =  this.selectedBookingType === BookingGuestType.HotelGuest ? this.ts.instant('Confirmation') : this.ts.instant('Membership');
  if(this.selectedBookingType === BookingGuestType.Others){
    this.applyBookingType();
  }
  }
  setActivityData(data) {
    this.activityService.selectedActivities = data;
    this.activityService.isDining = false;
    this.activityService.isNonDining = false;
    this.activityService.LocationList = data.venueLevelLocation;
    this.activityService.InstructorList = data.venueLevelInstructors;
    this.activityService.AllocationTypes = data.venueLevelAllocationMappings;
    this.activityService.restaurantWidgetId = data.restaurantWidgetId;
  }

  checkDataPresent(retainSessionValue = true) {
    if (!this.activityService.isDining && !this.activityService.isNonDining) {
      if (Object.keys(this.activityService?.selectedActivities)?.length !== 0 || this.activityService.fromConfirmation) {
        this.classDetail = this.activityService.selectedActivities;
        if (this.classDetail) {
          this.activityService.selectedSpecialMeal = this.classDetail;
          this.selectedActivityData = this.classDetail;
        }
        this.selectedClassActivity(this.selectedActivityData);
      } else if(this.route.snapshot.queryParams.specialMealId){
        this.activityService.navigateToUrl(`list` ,null, "/" + this.route.snapshot.queryParams.specialMealId );
      }
      else{
        let propertyId = this.route.snapshot.params.restaurantId;
        const isSessionComponentReload = sessionStorage.getItem('isSessionComponentReload');
        sessionStorage.removeItem('isSessionComponentReload');
        this.activityService.navigateToUrl(`list`, isSessionComponentReload !== 'true' ? { propertyId } : null);
      }
    } else if (this.activityService.isDining) {
      if (Object.keys(this.activityService?.selectedDining)?.length !== 0 || this.activityService.fromConfirmation) {
        this.isTimeDropList = this.activityService.selectedDining.WidgetCustomization?.TimeSlotType == "DropDown" ? true : false;
        this.initializeData(this.activityService?.selectedDining);
        // Filter special Meals based on available date and current date
        this.availableSpecialMeals = _.sortBy(this.activityService.selectedDining?.AvailableSpecialMeals.filter(meal => {
          if (!this.isEdit && meal.StartDate && meal.EndDate) {
            let nexAvailableMealDate = this.findNextAvailableDate(meal, this.activityService.dateFilterStartDate);
            return (nexAvailableMealDate >= new Date(meal.StartDate) && nexAvailableMealDate <= new Date(meal.EndDate)) || (nexAvailableMealDate <= new Date(meal.StartDate) && nexAvailableMealDate <= new Date(meal.EndDate))
          } else if (this.isEdit && this.activityService.editData?.SpecialMealId) {
            return meal.Id === this.activityService.editData?.SpecialMealId;
          } else {
            return meal;
          }
        }), "SortOrder");
        if (this.activityService.selectedDiningSpecialMeal?.Id || this.activityService.editData) {
          let mealSelected = this.activityService.selectedDiningSpecialMeal || this.activityService.editData.SpecialMeal;
          this.activityService.mealWithConfig = this.availableSpecialMeals.find(meal => meal.Id == mealSelected?.Id && !this.activityService.selectedDiningSpecialMeal?.ShowOtherActivities)
          if(this.activityService.mealWithConfig){
            this.availableSpecialMeals = [this.activityService.mealWithConfig];
          this.activityService.loadConfigBasedStyles(this.activityService.mealWithConfig);
          }
        }
        this.addAnySeatingOptionInMasterList();
        this.seatingAreaSeatingTypeMappings = (this.activityService?.selectedDining?.SeatingAreaSeatingTypeMappings && this.activityService?.selectedDining.SeatingAreaSeatingTypeMappings.length > 0) ? this.activityService.selectedDining.SeatingAreaSeatingTypeMappings : [];
        this.classDetail = this.findDiningSpecialMeal();
        this.activityService.selectedSpecialMeal = this.classDetail;
        this.selectedActivityData = this.classDetail;
        this.TimeSlotUnitInMinutes = this.activityService.selectedDining.TimeSlotUnitInMinutes;
        if (this.classDetail && this.availableSpecialMeals.length > 0 && this.showSpecialEvent) {
          this.availableSpecialMeals.forEach(x => { x.isSelected = false; });
          this.availableSpecialMeals[0].isSelected = true;
          this.selectedSpecialMeal(this.selectedActivityData, true, retainSessionValue);
        } else {
          this.showSpecialEvent = false;
          this.normalTableReservation(retainSessionValue, this.activityService.selectedDining?.MaxPartySize);
        }
      } else {
        let propertyId = this.route.snapshot.params.restaurantId;
        this.activityService.navigateToUrl(`list`, { propertyId });
      }
    } else {
      // Non Dining code
      this.bShowLocation = true;
      if (Object.keys(this.activityService?.selectedNonDining)?.length !== 0 || this.activityService.fromConfirmation) {
        this.isTimeDropList = this.activityService.selectedNonDining.WidgetCustomization?.TimeSlotType == "DropDown" ? true : false;
        this.initializeData(this.activityService?.selectedNonDining);

        this.seatingAreaSeatingTypeMappings = (this.activityService?.selectedNonDining?.SeatingAreaSeatingTypeMappings && this.activityService?.selectedNonDining.SeatingAreaSeatingTypeMappings.length > 0) ? this.activityService.selectedNonDining.SeatingAreaSeatingTypeMappings : [];
        this.selectedActivityData = this.classDetail;
        this.normalTableReservation(retainSessionValue, this.activityService.selectedNonDining?.MaxPartySize);
        this.TimeSlotUnitInMinutes = this.activityService.selectedNonDining.TimeSlotUnitInMinutes;
        this.durationControl.setValue(this.TimeSlotUnitInMinutes);
        this.filteredDurationOptions = this.durationControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            return value ? this._filter(value as string) : this.durationList.slice();
          }),
        );
        this.setGuestAndCoverTypes(this.activityService?.selectedNonDining, retainSessionValue);
        this.generateDurationList();
      } else {
        let propertyId = this.route.snapshot.params.restaurantId;
        this.activityService.navigateToUrl(`list`, { propertyId });
      }
    }
  }


  findDiningSpecialMeal() {
    if (this.isEdit && !this.activityService?.editData?.SpecialMealId) {
      return null;
    } else {
      if ((this.isEdit && this.activityService?.editData?.SpecialMealId) || this.activityService.sessionFilterValue?.selectedSpecialMealId) {
        return this.isEdit && this.activityService?.editData.SpecialMealId ? this.availableSpecialMeals.find(specialMeal =>
          specialMeal.Id === this.activityService?.editData.SpecialMealId) : this.availableSpecialMeals.find(specialMeal =>
            specialMeal.Id === this.activityService.sessionFilterValue?.selectedSpecialMealId);
      } else {
        return this.activityService.selectedDiningSpecialMeal || this.availableSpecialMeals[0];
      }
    }
  }

  // Initialize Dining/Non-Dining Data
  initializeData(selectedData: any) {
    this.currentFromDate = this.activityService.chosenStartDate ? this.activityService.chosenStartDate : this.activityService.dateFilterStartDate;
    this.currentToDate = this.activityService.dateFilterEndDate;
    this.seatingAreaMasterList = selectedData?.SeatingAreaList;
    this.seatingTypesMasterList = (selectedData?.SeatingTypeList && selectedData?.SeatingTypeList.length > 0) ? selectedData.SeatingTypeList.map(type => {
      type.typeColor = 'rgba(' + type.Color.R + ',' + type.Color.G + ',' + type.Color.B + ',' + type.Color.A + ')'
      return type;
    }) : [];
    this.daysForReservation = selectedData.DaysForReservation;
    let restaurant = selectedData;
    this.openHourDays = (restaurant.OpenHourDays && restaurant.OpenHourDays.length > 0) ? restaurant.OpenHourDays : [];
    this.CustomOpenHours = (restaurant.CustomOpenHours && restaurant.CustomOpenHours.length > 0) ? restaurant.CustomOpenHours : [];

    if(!this.openHourDays?.length && this.CustomOpenHours?.some(custDay => !custDay.Closed)){
      // this.openHourDays = this.CustomOpenHours.map(customDay => new Date(customDay.Date).getDay());
      let minDate = null;
      let maxDate = null;
      this.CustomOpenHours.forEach(customDay => {
        if(!customDay.Closed && (new Date(customDay.Date) > maxDate || !maxDate)){
          maxDate = new Date(customDay.Date);
        }
        if(!customDay.Closed && (new Date(customDay.Date) <= minDate || !minDate)){
          minDate = new Date(customDay.Date);
        }
        // this.openHourDays.push(new Date(customDay.Date).getDay());
      })
      if(maxDate){
        this.propertyMaxDateAllowed = new Date(maxDate);
        this.diningMaxDate = new Date(maxDate);
      }
      if(minDate){
        this.activityService.currentDateTime = minDate;
      }
    }
    this.setNoteType();
    this.notesOptions = this.addCategoryPreferencesNotes(this.noteType, this.notesOptions);
  }

  specialMealReservation() {
    this.resetReservationDetails(true);
    this.checkDataPresent(false);
    this.setBookingType();
  }

  normalTableReservation(retainSessionValue = true, MaxPartySize: Number) {
    this.activityService.isSpecialMeal = false;
    this.activityService.isTableReservation = this.activityService.isDining ? true : false;
    this.activityService.selectedSpecialMeal = null;
    if(this.activityService.isDining)
    {
      this.getCoverTypesReservation();
    }
    this.generatePartySize({ MinPartySize: 1, MaxPartySize });
    this.resetReservationDetails(false);
    this.setAvailableDate(null);
    this.setAvailableSeatings(null);
    if (this.activityService.isDining) {
      this.checkSessionorSlotAvailability(true, false, retainSessionValue);
      this.setBookingType();
    }
  }

  resetReservationDetails(isSpecialMeal) {
    this.showSpecialEvent = isSpecialMeal;
    if(this.coverTypes.length > 0) {
      this.coverTypes = this.coverTypes.map(x => { return { id: x.Id, name: x.Name, value: 0, price: x?.Price } });
      this.coverTypes[0].value = this.minSizeAllowed;
    }
    this.selectedDiningSlots = [];
    this.selectedActivityData = 0;
    this.currentBookingSize = 1;
    if (!this.isTimeDropList) {
      this.checkedDiningLocalTime = '';
      this.checkedItem = false;
    }
    this.selectedSeatingArea = 0;
  }

  addAnySeatingOptionInMasterList() {
    (this.seatingAreaMasterList.findIndex(area => (area.Id === 0 || area.Id === null)) > -1) || this.seatingAreaMasterList.splice(0, 0, { Id: 0, Name: this.ts.instant('AnySeatingArea') });
    (this.seatingTypesMasterList.findIndex(type => (type.Id === 0 || type.Id === null)) > -1) || this.seatingTypesMasterList.splice(0, 0, { Id: 0, Description: this.ts.instant('AnySeatingType') });
  }

  changeFromDate() {
    this.activityService.chosenStartDate = new Date(this.currentFromDate);
    this.activityService.chosenStartDate.setHours(0,0,0);
    this.showAvailableDates = true;
    if (this.activityService.isNonDining) {
      this.bIsSlotReloadRequired = true;
      if (this.activityService.operation === operationType.edit) this.updateNonDiningSlotTime();
    } else if (this.activityService.isDining) {
      this.diningSlotChangeListners('');
    }
    if (!this.isMultiSlotSelection || this.currentFromDate > this.currentToDate) {
      this.currentToDate = this.currentFromDate;
    }
  }
  checkSessionorSlotAvailability(isIntial = false, filterChanges = false, retainSessionValue = true) {
    // this.setBookingData();
      if(!this.currentBookingSize){
        this.currentBookingSize = this.getCoverTypesize();
      }
    if (this.activityService.sessionFilterValue && Object.keys(this.activityService.sessionFilterValue)?.length !== 0 && isIntial && retainSessionValue) {
      this.coverTypes = this.activityService.sessionFilterValue.coverTypes;
      this.bookingTypes = this.activityService.sessionFilterValue.bookingTypes;
      this.currentFromDate = new Date(this.activityService.sessionFilterValue.currentFromDate) || "";
      this.currentToDate = new Date(this.activityService.sessionFilterValue.currentToDate) || "";
      this.currentBookingSize = this.activityService.sessionFilterValue.currentBookingSize;
      this.sessionSlotsAvailableDates = this.activityService.sessionFilterValue.sessionSlotsAvailableDates;
      this.notesOptions = this.activityService.sessionFilterValue.notes;
      this.selectedSeatingArea = this.activityService.sessionFilterValue.selectedSeatingArea || 0;
      this.selectedSeatingType = this.activityService.sessionFilterValue.selectedSeatingType || 0;
      this.checkedDiningLocalTime = this.activityService.sessionFilterValue.checkedDiningLocalTime;
      this.marketingFlag = this.activityService.sessionFilterValue.marketingFlag;
      this.promoCodeDetail = this.activityService.sessionFilterValue.promoCodeDetail;
    } else if (this.activityService.fromConfirmation && isIntial && retainSessionValue) {
      this.coverTypes = this.activityService?.editData?.Covers?.filter(cover => cover.CoverTypeId)?.length > 0 ? _.uniqBy(this.activityService?.editData?.Covers?.map(cover => { return { id: cover.CoverTypeId, name: cover.CoverTypeName, value: cover.Covers }  }), 'id') : [];
      this.bookingTypes = this.activityService?.editData?.Covers?.filter(cover => cover.BookingTypeId)?.length > 0 ? _.uniqBy(this.activityService?.editData?.Covers?.map(cover => { return { id: cover.BookingTypeId, name: cover.BooKingTypeName, value: 0 }  }), 'id') :  this.activityService?.editData?.BookingTypes || [];
      this.currentFromDate = this.activityService.isDining ? new Date(this.activityService?.editData?.ReservedFor) : new Date(this.activityService?.editData?.StartDate) || "";
      this.currentToDate = this.activityService.isDining ? new Date(this.activityService?.editData?.ReservedFor) : new Date(this.activityService?.editData?.EndDate) || "";
      this.currentBookingSize = this.activityService?.editData?.Size;
      this.checkedDiningLocalTime = this.activityService?.editData?.ReservedFor;
      this.selectedSeatingArea = this.activityService?.editData?.SeatingAreaId || 0;
      this.selectedSeatingType = this.activityService?.editData?.SeatingTypeId || 0;
      this.isCommunalTable = this.activityService?.editData?.IsCommunalTable;
      this.marketingFlag = this.activityService?.editData?.Contact?.MarketingOptedIn;
      this.currentInstructors = this.activityService.editData?.StaffIds.length ? this.activityService.editData?.StaffIds[0] : null;
      if(!this.selectedActivityData)
      this.selectedActivityData = {};
      this.selectedActivityData.CoverTypeQuantities = this.activityService?.editData?.CoverTypeQuantities;
      this.sessionSlotsAvailableDates = [];
      if(this.activityService.isDining) {
      this.getFormattedBookingTypeValues();
      this.getFormattedCoverTypeValues();
      }
    }
    this.isValidFormValues();
    this.getavailableSlots(
      this.currentInstructors,
      this.currentLocations,
      this.currentFromDate,
      this.currentToDate,
      this.overAllBookingSize,
      isIntial,
      filterChanges
    );
  }

  spliceTimeArrayForTheSelectedMealTab(chip: MatChip, selectedMealTab) {
    this.activityService?.selectedDining?.MealTabs.forEach(tab => { if (selectedMealTab.Id === tab.Id) { tab.selected = !tab.selected } else { tab.selected = false } });
    chip.toggleSelected();
    let requiredTimeArray = [];
    if (selectedMealTab && selectedMealTab.selected) {
      let startHours = selectedMealTab.StartTime.split(':')[0];
      let startMins = selectedMealTab.StartTime.split(':')[1];
      let endHours = selectedMealTab.EndTime.split(':')[0];
      let endMins = selectedMealTab.EndTime.split(':')[1];
      let selectedDate = moment(this.currentFromDate).format('YYYY-MM-DD');
      let startTime = moment(selectedDate).clone().add(startHours, 'hours').add(startMins, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
      let endTime = moment(selectedDate).clone().add(endHours, 'hours').add(endMins, 'minutes').format("YYYY-MM-DDTHH:mm:ss");
      if (moment(startTime) > moment(endTime)) {
        endTime = moment(endTime).add(1, 'day').format("YYYY-MM-DDTHH:mm:ss");
      }
      if (this.originalTimeSlotList.length > 0) {
        this.originalTimeSlotList.forEach(time => {
          if (Utilities.datetimeBetween(new Date(startTime), new Date(endTime), new Date(time))) {
            requiredTimeArray.push(time);
          }
        })
      }
      this.selectedDiningSlots = requiredTimeArray;
    } else {
      this.selectedDiningSlots = this.originalTimeSlotList;
    }
    if (this.isTimeDropList) {
      this.checkedItem = true;
      this.checkedDiningLocalTime = this.selectedDiningSlots[0];
    }
  }

  showOtherDaysAvailable() {

    let MaxAlternateDays = this.activityService.selectedDining.MaxAlternateDays;
    let MaxDate = this.diningMaxDate;
    if (this.activityService.isNonDining) {
      MaxAlternateDays = this.activityService.selectedNonDining.MaxAlternateDays;
      MaxDate = this.nonDiningMaxDate;
    }

    if(this.bookingTypeMaxDate && moment(this.bookingTypeMaxDate).diff(new Date(MaxDate), 'days') < 0) {
      MaxDate = new Date(this.bookingTypeMaxDate);
      MaxDate.setDate(this.bookingTypeMaxDate.getDate() - 1);
    }

    this.otherAvailableDays = [];
    let tempDate = new Date(this.currentFromDate);
    for (let i = 1; i <= MaxAlternateDays; i++) {
      let curDate = tempDate;
      const isInitial = i === 1 ? true : false;
      if (curDate < new Date(MaxDate)) {
        if (isInitial) {
          this.otherAvailableDays.push({ Id: i, value: new Date(tempDate).toISOString(), isSelected: false });
        }
        curDate = this.findNextAvailableDate(this.selectedActivityData, curDate, true, true, isInitial);
        if (curDate && curDate < new Date(MaxDate) && this.openHourDays.includes(curDate.getDay())) {
          tempDate = new Date(curDate);
          const existingDateObj = this.otherAvailableDays.find(dayObj => dayObj.value === tempDate.toISOString());
          if (!existingDateObj || !Object.keys(existingDateObj)?.length) {
            this.otherAvailableDays.push({ Id: i, value: tempDate.toISOString(), isSelected: false, date: tempDate })
          }
        }
      }
    }

    let customDates = this.getCustomAvailableDays(this.openHourDays?.length ? this.otherAvailableDays.length : this.otherAvailableDays.length + 1);

    let quickAvaialbleDays = sortByDate(_.uniqBy([...this.otherAvailableDays, ...customDates], "value"));

    this.otherAvailableDays = quickAvaialbleDays.slice(0, MaxAlternateDays + 1);
  }

  getCustomAvailableDays(startId){
    let availableDays = [];
    this.CustomOpenHours.forEach((customDay, index) => {
      let tempDate = new Date(customDay.Date);
      if(!customDay.Closed && tempDate > this.currentFromDate){
        availableDays.push({ Id: startId + index, value: tempDate.toISOString(), isSelected: false, date: tempDate })
      }
    })

    return availableDays;
  }

  //Highlight date based on selection
  checkIfDateSelected(otherDate) {
    let isSelected = false;
    if (new Date(this.currentFromDate).toISOString() === otherDate) {
      isSelected = true;
    }
    return isSelected;
  }

  addDays(date, days, count) {
    var result = new Date(date);
    let dateTemp = new Date(date);
    dateTemp.setDate(dateTemp.getDate() + count);


    if (this.selectedActivityData?.FrequencyTypeIds?.includes(dateTemp.getDay())) {
    } else {
      result = new Date(this.findNextAvailableDate(this.selectedActivityData, dateTemp, true, true));
    }

    var daysDiff = moment(moment(result).format('YYYY-MM-DD')).diff(moment(this.diningMaxDate).format('YYYY-MM-DD'), 'days')
    return daysDiff <= 0 ? result : null;
  }

  chooseAvailableDate(selectedDay) {
    this.currentFromDate = new Date(selectedDay.value);
    this.activityService.chosenStartDate = this.currentFromDate;
    if (this.activityService.isDining) {
      this.checkSessionorSlotAvailability(false, true);
      this.diningSlotChangeListners('');
    }
    else if (this.activityService.isNonDining) this.checkNonDiningSessionorSlotAvailability(false, true);
  }

  getavailableSlots(instructors, location, fromDate, toDate, bookingSize, isInitial = false, filterChanges = false) {
    this.sessionSlotsAvailableDates = [];
    this.classLessonList = [];
    this.availableSessions = [];
    this.selectedIndex = 0;
    const requestedObject = {
      ActivityId: +this.selectedActivityData?.SpecialMealId || null,
      // AvailabilityCriteria: this.getAvailabilityCriteria([location], [instructors]), // Uncomment this if filters are added
      AvailabilityCriteria: 0,
      StartDate: moment(fromDate).format('YYYY-MM-DD'),
      EndDate: moment(toDate).format('YYYY-MM-DD'),
      // PreferredLocationId: [location], // Uncomment this if filters are added
      // PreferredStaffId: [instructors], // Uncomment this if filters are added
      PreferredLocationId: [],
      PreferredStaffId: [],
      BookingSize: bookingSize,
      ClassType: this.selectedActivityData?.ClassType || null,
      reservationIdToIgnore: this.activityService?.editData?.Id || null
    } as ActivitySlotRequestDTO;

    if (this.activityService.isDining) { // For restaurants call Dining
      this.getSlotsForDining(requestedObject, isInitial);
    } else if (this.activityService.isNonDining) {
      this.getSlotInitial = true;
      this.getSlotsForNonDining(requestedObject, isInitial);
    } else {
      this.getSlotInitial = true;
      this.getSlotsForClass(requestedObject, isInitial, filterChanges);
    }
  }

  getAvailabilityCriteria(locations, instructors) {
    if (!locations?.length && !instructors?.length) {
      return AvailabilityCriteria.None;
    } else if (locations?.length && !instructors?.length) {
      return AvailabilityCriteria.IncludeLocation;
    } else if (!locations?.length && instructors?.length) {
      return AvailabilityCriteria.IncludeInstructor;
    } else {
      return AvailabilityCriteria.IncludeLocationAndInstructor;
    }
  }

  setNoteType() {
    this.noteType = (!this.activityService.isDining && !this.activityService.isNonDining) ?
      this.selectedActivityData?.NotesType :
      (this.activityService.isNonDining ? this.activityService?.selectedNonDining?.WidgetCustomization?.NotesType
        : this.activityService?.selectedDining?.WidgetCustomization?.NotesType);
  }

  selectedClassActivity(data) {
    this.selectedActivityData = data;
    this.setNoteType();
    this.isSessionClass = this.selectedActivityData?.ClassType === ClassType.Session;
    if (data?.CoverTypePrices?.length > 0) {
      let minimumQuantity = data.CoverTypePrices?.filter(type => type.MinimumQuantity == 0);
      if (minimumQuantity?.length && minimumQuantity?.length == data?.CoverTypePrices?.length) {
        this.minSizeAllowed = data.MinPartySize;
      } else {
        let minSize = data.CoverTypePrices?.filter(type => type.MinimumQuantity > 0);
        this.minSizeAllowed = minSize[0].MinimumQuantity;
      }
    } else {
      this.minSizeAllowed = data.MinPartySize;
    }
    this.coverTypes = data?.CoverTypePrices?.map(type => {
      return {
        id: type.Id,
        name: type.CoverTypeName,
        value: type.MinimumQuantity > 0 ? type.MinimumQuantity : 0,
      };
    });
    let minimumQuantity = this.coverTypes.filter(type => type.MinimumQuantity == 0);
    if (minimumQuantity?.length && minimumQuantity.length == data?.CoverTypePrices?.length) {
      minimumQuantity[0].value = this.minSizeAllowed;
    }
    this.activityHeadlines = data.ActivityAttributes;
    this.bookingTypes = data?.BookingTypeActivitiesMappings?.map(type => {
      return {
        id: type.Id,
        name: type.Name,
        value: 0
      };
    });

    this.calculatePartySize();

    this.instructorList = this.getInstructor(data.StaffValues);
    this.locationList = this.getLocations(data.LocationId);
    this.isMultiSlotSelection = data.EnableMultiSlotSelection;
    this.venueAllocationMappings = data.AllocationTypes;
    this.showSessionorSlots = false;
    this.selectedClassSchedule = [];
    this.sessionSlotsAvailableDates = [];
    this.setInitialData();
  }

  setInitialData() {
    this.currentInstructors = null;
    this.currentLocations = null;;
    this.currentFromDate = this.activityService.dateFilterStartDate; // this.selectedActivityData.StartDate;
    this.currentToDate = this.activityService.dateFilterEndDate; // this.selectedActivityData.EndDate;
    this.overAllBookingSize = this.minSizeAllowed;
    if (this.bookingTypes?.length) {
      this.bookingTypes[0].value = this.minSizeAllowed;
    }
    if (this.coverTypes?.length) {
      let minimumQuantity = this.coverTypes?.filter(covers => covers.value === 0);
      if (minimumQuantity.length === this.coverTypes.length) {
        this.coverTypes[0].value = this.minSizeAllowed;
      }
    }
    if (!this.coverTypes?.length && !this.bookingTypes?.length) {
      this.currentBookingSize = this.minSizeAllowed;
    }
    this.notesOptions = this.addCategoryPreferencesNotes(this.noteType, this.notesOptions);
    console.log(this.currentInstructors, this.currentLocations);
    this.checkSessionorSlotAvailability(true);
  }

  selectedSpecialMeal(meal, isInitial = false, retainSessionValue = true , manualSelect?: boolean) {
    this.selectedActivityData = meal;
    this.activityService.selectedSpecialMeal = meal;
    if (!this.isTimeDropList) {
      this.checkedDiningLocalTime = '';
      this.checkedItem = false;
    }
    this.activityService.isSpecialMeal = true;
    this.activityService.isTableReservation = false;
    this.coverTypes = [];
    this.setAvailableSeatings(meal);
    this.setAvailableDate(meal);
    this.generatePartySize(meal);
    this.generateCoverType(meal);
    this.checkSessionorSlotAvailability(isInitial, false, retainSessionValue);
    if(manualSelect) this.setBookingType();
  }

  setAvailableSeatings(specialMeal: any) {
    if (specialMeal && specialMeal.SeatingAreaId && specialMeal.SeatingAreaId > 0) {
      this.selectedSeatingArea = specialMeal.SeatingAreaId;
      this.seatingArea = this.seatingAreaMasterList.filter(x => x.Id == specialMeal.SeatingAreaId).map(x => { return { id: x.Id, value: x.Name } });
    } else {
      this.seatingArea = this.seatingAreaMasterList.map(x => { return { id: x.Id, value: x.Name } });
    }
     if (this.seatingArea?.length) {
      this.loadSeatingTypes((this.activityService.isNonDining && this.isEdit) ? this.activityService?.editData.SeatingAreaId : null);
    }
  }

  loadSeatingTypes(seatingAreaId: number) {
    let MappedSeatingTypes = [];
    MappedSeatingTypes = this.seatingAreaSeatingTypeMappings.filter(t => t.SeatingAreaId == seatingAreaId || seatingAreaId == 0 || seatingAreaId == null).map(x => { return x.SeatingTypeId });
    this.seatingType = MappedSeatingTypes.length > 0 ? this.seatingTypesMasterList.filter(x => MappedSeatingTypes.indexOf(x.Id) > -1 || x.Id == 0 || x.Id === null).map(x => { return { id: x.Id, value: x.Description, color: 'rgba(' + x.Color?.R + ',' + x.Color?.G + ',' + x.Color?.B + ',' + x.Color?.A + ')' } }) : [{ id: 0, value: this.ts.instant('AnySeatingType') }];
    this.seatingType?.forEach(seatingType => {
      this.seatingTypeNames[seatingType.id] = seatingType.value;
    });
  }

  setAvailableDate(specialMeal) {
    let selectedDate = moment(specialMeal?.StartDate).isSameOrBefore(this.activityService.dateFilterStartDate) ? this.activityService.dateFilterStartDate : specialMeal?.StartDate; 
    this.currentFromDate = this.findNextAvailableDate(specialMeal, this.activityService.chosenStartDate ? this.activityService.chosenStartDate : (selectedDate || this.activityService.dateFilterStartDate));
    if(this.currentFromDate && this.currentFromDate == 'Invalid Date') { // Condition added for invalid date issue #39356
      this.currentFromDate = selectedDate || this.activityService.dateFilterStartDate;
    }
    if (specialMeal && specialMeal.StartDate && specialMeal.EndDate) {
      if (new Date(specialMeal.StartDate).setHours(0, 0, 0, 0) > new Date(new Date(this.currentFromDate).setDate(new Date(this.currentFromDate).getDate() + this.daysForReservation - 1)).setHours(0, 0, 0, 0)) {
        this.activityService.
          openSnackBar(this.ts.instant('BookingYetToOpenMsg'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
        return;
      }
      if (new Date(specialMeal.EndDate).setHours(0, 0, 0, 0) > new Date(new Date(this.currentFromDate).setDate(new Date(this.currentFromDate).getDate() + this.daysForReservation - 1)).setHours(0, 0, 0, 0)) {
        this.diningMaxDate = new Date(new Date(this.currentFromDate).setDate(new Date(this.currentFromDate).getDate() + this.daysForReservation - 1));
      }
      else {
        this.diningMaxDate = new Date(specialMeal.EndDate);
      }
    }
    else {
      this.diningMaxDate = new Date(new Date().setDate(new Date().getDate() + this.daysForReservation - 1));
      if(this.CustomOpenHours?.length == 0 && this.openHourDays?.length == 0)
        this.diningMaxDate = new Date();
    }
    this.diningMaxDate = new Date(new Date(this.diningMaxDate).setHours(0, 0, 0, 0));
    if(this.propertyMaxDateAllowed < this.diningMaxDate){
      this.diningMaxDate = new Date(this.propertyMaxDateAllowed);
    }
    this.showNextArrow = new Date(this.diningMaxDate) > new Date(this.findNextAvailableDate(specialMeal, this.currentFromDate, true, true));
    this.showParticularDays = this.EnableAndDisableDates(specialMeal);
    if( specialMeal?.StartDate && new Date(specialMeal?.StartDate) > this.activityService.currentDateTime){
      this.activityService.currentDateTime = new Date(new Date(specialMeal?.StartDate).setHours(0, 0, 0, 0));
    }
    // this.activityService.currentDateTime = new Date(this.currentFromDate);
    this.SetInitialDate((this.activityService.chosenStartDate && this.activityService.chosenStartDate.toString() != 'Invalid Date') ? this.activityService.chosenStartDate : this.currentFromDate);

    if (this.activityService.isNonDining) {
      this.nonDiningMaxDate = this.diningMaxDate;
      this.diningMaxDate = null;
    }
  }

  SetInitialDate(date: Date) {
    let IsHoliday = false;
    IsHoliday = this.IsHoliday(date)
    let currentDateTime = this.activityService.currentDateTime;
    currentDateTime.setHours(0,0,0,0);
    if (IsHoliday || date < currentDateTime) {
      date.setDate(date.getDate() + 1);
      this.SetInitialDate(date);
    }
    else {
      this.currentFromDate = date;
    }
  }

  IsHoliday(date: Date) {
    let isHoliday = false;
    isHoliday = this.IsCustomDay(date) ? this.IsCustomHoliday(date) : this.openHourDays?.length ? !this.openHourDays.includes(date.getDay()) : false;
    return isHoliday;
  }

  IsCustomDay(date: Date) {
    for (let holiday of this.CustomOpenHours) {
      let date1 = moment(holiday.Date).format('LL');
      let date2 = moment(date).format('LL');
      if (date1 == date2) {
        return true;
      };
    }
    return false;
  }

  EnableAndDisableDates(specialMeal) {
    if ((specialMeal?.FrequencyTypeIds && specialMeal?.FrequencyTypeIds != null) || (this.openHourDays && this.openHourDays.length > 0)) {
      if (specialMeal?.FrequencyTypeIds != null && this.openHourDays.length > 0) {
        let mergedArray = [];
        specialMeal?.FrequencyTypeIds.every(a => this.openHourDays.includes(a) ? mergedArray.push(a) : '');
        return this.setFrequencyDate(mergedArray);
      }
      else if (specialMeal?.FrequencyTypeIds != null && this.openHourDays.length <= 0) {
        return this.setFrequencyDate(specialMeal?.FrequencyTypeIds);
      }
      else {
        return this.setFrequencyDate(this.openHourDays);
      }
    }
    else {
      return this.setFrequencyDate([])
    }
  }


  // To get Available date based on FrequencyTypeIds [0,1,2,3,4,5,6]
  findNextAvailableDate(specialMeal, date, isNext = true, fromAvailableDates = false, isInitial = false) {
    let daysNumList = specialMeal?.FrequencyTypeIds || this.openHourDays || [0, 1, 2, 3, 4, 5, 6];
    daysNumList = daysNumList.sort((a, b) => { return a - b; });
    let dayNum = new Date(date).getDay() || 0;
    let tempDate = new Date(date);
    let finalDate = null;

    if (daysNumList.length > 0 && !daysNumList.includes(dayNum) || fromAvailableDates) {
      if (isNext) {
        const startCount = dayNum === 6 ? 0 : dayNum;
        for (let count = dayNum; count < dayNum + 7; count++) {
          tempDate.setDate(tempDate.getDate() + 1);
          if (daysNumList.includes(new Date(tempDate).getDay()) && !finalDate) {
            finalDate = new Date(new Date(tempDate).setHours(0, 0, 0, 0));
          }
        }
      } else {
        for (let count = dayNum; count < dayNum + 7; count++) {
          tempDate.setDate(tempDate.getDate() - 1);
          if (daysNumList.includes(new Date(tempDate).getDay()) && !finalDate) {
            finalDate = new Date(new Date(tempDate).setHours(0, 0, 0, 0));
          }
        }
      }
    }
    return finalDate ? finalDate : (fromAvailableDates && !isInitial) ? null : tempDate;
  }

  setFrequencyDate(days) {
    let frequencyDate = (d: Date): boolean => {
      if (d !== null) {
        const date = (new Date(d) || new Date());
        const dayDate = date.getDate();
        const day = date.getDay();
        let enableDate = days.includes(day);
        if (this.CustomOpenHours.length > 0 && this.IsCustomDay(date)) {
          let IsHoliday = this.IsHoliday(date);
          enableDate = !IsHoliday;
        }
        return enableDate;
      } else {
        return false;
      }
    }
    return frequencyDate;
  }

  IsCustomHoliday(date: Date) {
    if (this.CustomOpenHours?.length) {
      for (let holiday of this.CustomOpenHours) {
        let date1 = moment(holiday.Date).format('LL');
        let date2 = moment(date).format('LL');
        if (date1 == date2) {
          return holiday.Closed;
        };
      }
    }
    return false;
  }

  generatePartySize(specialMeal) {
    this.bookingSizeArray = [];
    this.overAllBookingSize = this.minSizeAllowed = specialMeal ? specialMeal.MinPartySize : 1;
    this.maxSizeAllowed = specialMeal ? specialMeal.MaxPartySize : 10;
    for (let index = 1; index <= this.maxSizeAllowed; index++) {
      this.bookingSizeArray.push({ id: index, value: index });
    }
    this.currentBookingSize = this.minSizeAllowed;
    if (this.coverTypes.length) this.coverTypes[0].value = String(this.minSizeAllowed);
    if (this.bookingTypes.length) this.bookingTypes[0].value = String(this.minSizeAllowed);
  }

  generateCoverType(meal) {
    let availableCoverTypes = this.activityService.selectedDining.AvailableSpecialMeals.filter(x => x.Id == meal.Id)[0].CoverTypePrices;
    if (meal.CoverTypePrices.length > 0) {
      this.coverTypes = availableCoverTypes.map(x => { return { id: x.Id, name: x.CoverTypeName, value: 0, price: x?.Price } });
      this.coverTypes[0].value = this.minSizeAllowed;
    }
    else {
      this.coverTypes = [];
    }
  }

  selectSpecialMeal(specialMealIndex , manualSelect) {
    if ((specialMealIndex || specialMealIndex === 0) && this.availableSpecialMeals[specialMealIndex]?.SpecialMealId !== this.selectedActivityData?.SpecialMealId) {
      this.availableSpecialMeals.forEach((x: any) => { x.isSelected = false; });
      if (this.availableSpecialMeals?.[specialMealIndex]) {
        this.availableSpecialMeals[specialMealIndex].isSelected = true;
        this.selectedSpecialMeal(this.availableSpecialMeals[specialMealIndex] , null , null , manualSelect);
      }
    }
  }

  changeDiningDate(nextOrPrev: string) {
    this.currentFromDate = new Date(this.currentFromDate);
    let daysDiffByMaxDate =  moment(this.bookingTypeMaxDate || this.diningMaxDate).diff(new Date(this.currentFromDate), 'days');
    if (nextOrPrev === 'next' && this.currentFromDate < new Date(this.diningMaxDate) && daysDiffByMaxDate > 0) {
      this.currentFromDate = new Date(this.currentFromDate.setDate(this.currentFromDate.getDate() + 1));
      this.currentFromDate = this.getNextAvailableDate();
      this.showNextArrow = new Date(this.diningMaxDate) > new Date(this.findNextAvailableDate(this.selectedActivityData, this.currentFromDate, true, true))
      this.checkSessionorSlotAvailability(false, true);
    }
    else if (nextOrPrev === 'prev' && this.currentFromDate > this.activityService.currentDateTime.setHours(0, 0, 0, 0)) {
      this.currentFromDate = new Date(this.currentFromDate.setDate(this.currentFromDate.getDate() - 1));
      this.currentFromDate = this.getPrevAvailableDate();
      this.showNextArrow = new Date(this.diningMaxDate) > new Date(this.findNextAvailableDate(this.selectedActivityData, this.currentFromDate, false, true))
      this.checkSessionorSlotAvailability(false, true);
    }

    this.diningSlotChangeListners('');

  }

  getNextAvailableDate(){
    let scheduledNextDay = this.findNextAvailableDate(this.selectedActivityData, this.currentFromDate, true);
    let customNextDay = this.CustomOpenHours.find(customDay => new Date(customDay.Date) > this.currentFromDate);

    return customNextDay && new Date(customNextDay?.Date) < scheduledNextDay ? new Date(customNextDay?.Date) : scheduledNextDay;
  }

  getPrevAvailableDate(){
    let scheduledPrevDay = this.findNextAvailableDate(this.selectedActivityData, this.currentFromDate, false);
    let customDaysReverse = this.CustomOpenHours.slice().reverse();
    let customPrevDay = customDaysReverse.find(customDay => new Date(customDay.Date) < this.currentFromDate);

    return customPrevDay && new Date(customPrevDay?.Date) > scheduledPrevDay ? new Date(customPrevDay?.Date) : scheduledPrevDay;
  }

  changeCoverTypeSize(nextOrPrev: string, index: number) {
    if (nextOrPrev === 'next' && this.coverTypes[index].value < this.maxSizeAllowed) { 
      this.coverTypes[index].value = this.coverTypes[index].value + 1; this.checkSessionorSlotAvailability(false, true); 
    }
    else if (nextOrPrev === 'prev' && this.coverTypes[index].value > 0) { 
      this.coverTypes[index].value = this.coverTypes[index].value - 1; this.checkSessionorSlotAvailability(false, true); 
    }
  }

  changePartySize(nextOrPrev: string) {
    if (nextOrPrev === 'next' && this.currentBookingSize < this.maxSizeAllowed) { this.currentBookingSize = this.currentBookingSize + 1; this.checkSessionorSlotAvailability(false, true); }
    else if (nextOrPrev === 'prev' && this.currentBookingSize > this.minSizeAllowed) { this.currentBookingSize = this.currentBookingSize - 1; this.checkSessionorSlotAvailability(false, true); }
  }

  changeTimeSlots(nextOrPrev: string) {
    if (nextOrPrev === 'next' && this.checkedDiningLocalTime !== this.selectedDiningSlots[this.selectedDiningSlots.length - 1]) { this.checkedDiningLocalTime = this.selectedDiningSlots[this.selectedDiningSlots.findIndex(slot => slot === this.checkedDiningLocalTime) + 1]; }
    else if (nextOrPrev === 'prev' && this.checkedDiningLocalTime !== this.selectedDiningSlots[0]) { this.checkedDiningLocalTime = this.selectedDiningSlots[this.selectedDiningSlots.findIndex(slot => slot === this.checkedDiningLocalTime) - 1]; }
  }

  applyToOtherDates(selectedDateIndex, event) {

    this.bookAllAvailableDates = event?.checked;
    let memberid;
    const selectedSessionIndexes =
      this.sessionSlotsAvailableDates[selectedDateIndex].AvailableSessions
        .map((session, index) => session.isChecked ? index : -1).filter(sessionIndex => sessionIndex !== -1);
    if (this.activityService.selectedGuest) {
      var { MembershipType: memberTypename, MemberActive: memberActive } = this.activityService.selectedGuest;
      const memberType = this.venueAllocationMappings
        .find(allocation => allocation.AllocationTypeName.trim().toLocaleLowerCase() === memberTypename.trim().toLocaleLowerCase());
      if (memberType) {
        memberid = memberType.AllocationTypeId;
      }
    }
    if (event.checked) {
      this.sessionsUnavailable = [];
      if (!selectedSessionIndexes || !selectedSessionIndexes.length) {
        this.activityService.
          openSnackBar(this.ts.instant('selectSessionsToApplyForAllDates'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
        this.bookAllAvailableDates = false;
        return false;
      }
      this.sessionSlotsAvailableDates.forEach(selectedDate => {
        selectedDate.AvailableSessions = selectedDate.AvailableSessions.map(session => {
          session.isChecked = false;
          return session;
        });
        selectedSessionIndexes.forEach(index => {
          if (selectedDate.AvailableSessions[index] &&
            (
              selectedDate.AvailableSessions[index].Availability?.AvailabilityType === AvailabilityType.Cancelled || selectedDate.AvailableSessions[index].Availability?.AvailabilityType === AvailabilityType.OpenToAll
              || (selectedDate.AvailableSessions[index].Availability?.AvailabilityType === AvailabilityType.OpenToSpecificMember
                && ((selectedDate.AvailableSessions[index].Availability?.AllocationTypeId === memberid)
                  || (this.IsMember(selectedDate.AvailableSessions[index].Availability) && memberid)) && memberActive)
            )
            && !selectedDate.AvailableSessions[index].disabled) {
            selectedDate.AvailableSessions[index].isChecked = true;
          } else {
            if (!this.sessionsUnavailable[index] || !this.sessionsUnavailable[index].dates) {
              //this.sessionsUnavailable[index] = { session: ('Session') + ' ' + (index + 1) + ' ' + ('notAvailableOn') + ' ', dates: '' };
              this.sessionsUnavailable[index] = { session: this.ts.instant('session') + ' ' + (index + 1) + ' ' + this.ts.instant('notAvailableOn') + ' ', dates: '' };
            }
            this.sessionsUnavailable[index].dates +=
              this.sessionsUnavailable[index].dates ? ', ' + moment(selectedDate.AvailableDate).format('LL')
                : moment(selectedDate.AvailableDate).format('LL');
          }
        });
      });
      this.sessionsUnavailable = this.sessionsUnavailable.filter(item => item);
      if (!this.sessionsUnavailable || !this.sessionsUnavailable.length) {
        // this.toastrService.success(this.ts.instant("Applied"), "", { timeOut: 3000, closeButton: true });
      } else {
        let errorMessage = '';
        const errObj = {
          ErrorDetails: {
            Error: this.sessionsUnavailable.map(session => {
              errorMessage = errorMessage + session.session + session.dates + '. ';
            })
          },
          ErrorType: true,
          dialogTitle: 'error'
        };
        this.activityService.openSnackBar(errorMessage, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
        // this.activityService.setMessageState(errorMessage, 0);
      }
    } else {
      this.uncheckSelectedSession();
    }
  }

  uncheckSelectedSession() {
    if (!this.isTimeDropList) {
      this.checkedItem = false;
      this.checkedDiningLocalTime = '';
      this.sessionSlotsAvailableDates.forEach(selectedDate => {
        selectedDate.AvailableSessions = selectedDate.AvailableSessions.map(session => {
          session.isChecked = false;
          return session;
        });
      });
    }
  }

  isValidFormValues(isReload?: boolean) {

    this.validGroupSize = false;

    const minsize = this.selectedActivityData?.MinPartySize || 1;
    const maxsize = this.selectedActivityData?.MaxPartySize || 10;

    let selectedSize = 0;
    let bookingTypeTotal = 0;
    let coverTypeTotal = 0;
    let guestTypeMinQuantity = true;

    if(this.activityService.isDining) {

    // if (this.bookingTypes?.length) {
    //   this.bookingTypes.forEach(bookType => {
    //     bookingTypeTotal += Number(bookType.value);
    //   });
    // }

    if (this.coverTypes?.length) {
      this.coverTypes.forEach(coverType => {
        coverTypeTotal += Number(coverType.value);
      });
    }

    if (this.bookingTypes?.length === 0 && this.coverTypes?.length === 0) {
      selectedSize = this.currentBookingSize;
    }
    else {
      selectedSize = coverTypeTotal;
    }
    // } else if (this.bookingTypes?.length && this.coverTypes?.length === 0) {
    //   selectedSize = bookingTypeTotal;
    // } else if (this.bookingTypes?.length === 0 && this.coverTypes?.length) {
    //   selectedSize = coverTypeTotal;
    // } else if (this.bookingTypes?.length && this.coverTypes?.length) {
    //   if (bookingTypeTotal !== coverTypeTotal) {
    //     this.activityService.openSnackBar(this.ts.instant('countsNotMatching'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
    //     return false;
    //   } else {
    //     selectedSize = bookingTypeTotal;
    //   }
    // }
  }else {

    selectedSize = this.currentBookingSize;
  }

    if (selectedSize < minsize || selectedSize > maxsize) {
      this.ts.get('MisMatchGroupSizeWithClass', { minsize: minsize, maxsize: maxsize }).subscribe(result => {
        this.activityService.openSnackBar(result, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
      });
      if (this.activityService.isDining) {
        this.selectedDiningSlots = [];
      } else if (this.activityService.isNonDining) {
        this.selectedNonDiningSlots = [];
      }
      else {
        this.sessionSlotsAvailableDates = [];
      }
      return false;
    }

    this.overAllBookingSize = selectedSize;
    this.validGroupSize = selectedSize >= minsize && selectedSize <= maxsize;

    if (this.selectedActivityData?.CoverTypePrices?.length && this.coverTypes?.length) {
      this.selectedActivityData?.CoverTypePrices?.map(type => {
        type.value = this?.sizeMapping?.sizes ? this.sizeMapping.sizes.filter(x => x.CoverTypeId == type.Id).reduce((res, curr) => res = res + curr.Covers, 0) : this.coverTypes.find(x => x.id == type.Id)?.value;
        return type;
      });
      this.selectedActivityData?.CoverTypePrices?.map(type => {
        if (type.MinimumQuantity > 0 && (type.value < type.MinimumQuantity)) {
          this.ts.get('guestTypeMinQuantityErrorMessage', { quantity: type.MinimumQuantity, guestType: type.CoverTypeName }).subscribe(result => {
            this.activityService.openSnackBar(result, this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
          });
          this.validGroupSize = false;
          return false;
        }
      })
    }


    if(this.sizeMapping?.errors?.length > 0) {
      return false;
    }

    if (isReload && this.activityService.displayLocationType !== LocationViewTypes.None) {
      this.getNonDiningLocationsApiHandler(false , isReload);
    }

  }

  IsMember(slot: any): boolean {
    if (!slot || !this.venueAllocationMappings) {
      return false;
    }
    const allocationType = this.venueAllocationMappings;
    const isAnyMember = allocationType.find(type => type.AllocationTypeId === slot.AllocationTypeId)?.AllocationTypeName === 'AnyMembers';
    return isAnyMember;
  }

  getInstructor(staffList) {
    let SelectedStaffList = [];
    if (staffList?.length > 1) {
      SelectedStaffList.push({ Id: -1, value: 'Any' });
    }
    staffList?.forEach(staff => {
      const selectedStaff = this.activityService?.InstructorList.filter(data => data.Id === staff.ServerId)[0];
      if (selectedStaff) {
        let serverval = 'Unnamed';
        if (selectedStaff) {
          if (selectedStaff.Name) {
            serverval = selectedStaff.Name;
          }
          if (selectedStaff.LastName) {
            serverval = serverval + ' ' + selectedStaff.LastName;
          }
        }
        selectedStaff.value = serverval;

        SelectedStaffList.push(selectedStaff);
      }
    });
    SelectedStaffList = SelectedStaffList.map(data => {
      return {
        id: data.Id,
        value: data.value
      };
    });

    return SelectedStaffList;
  }

  getLocations(locationList) {
    let SelectedLocationList = [];
    if (locationList?.length > 1) {
      SelectedLocationList.push({ Id: -1, value: 'Any' });
    }
    locationList?.forEach(location => {
      const selectedLocation = this.activityService?.LocationList.filter(data => data.Id === location.LocationId)[0];
      if (selectedLocation) {
        selectedLocation.value = selectedLocation.Name;
        SelectedLocationList.push(selectedLocation);
      }
    });
    SelectedLocationList = SelectedLocationList.map(data => {
      return {
        id: data.Id,
        value: data.value
      };
    });
    return SelectedLocationList;
  }

  getSlotsForDining(reqObj, isInitial = false) {
    this.activityService.startLoader();
    this.subscriptions.add(this.activityService.GetRestaurantDateAvailability(
      this.selectedActivityData?.restaurantWidgetId || this.activityService.selectedDining?.RestaurantId,
      reqObj.BookingSize,
      this.isCommunalTable,
      true,
      moment(this.currentFromDate).format('YYYY-MM-DD'),
      this.selectedSeatingArea ? this.selectedSeatingArea : null,
      this.activityService.operation === operationType.edit ? this.activityService?.editData?.Id : null,
      this.showSpecialEvent && +this.selectedActivityData?.SpecialMealId ? +this.selectedActivityData?.SpecialMealId : null,
      this.selectedSeatingType ? this.selectedSeatingType : null
    ).subscribe(data => {
      this.activityService.stopLoader();
      this.showAvailableDates = true;
      this.activityService?.selectedDining?.MealTabs.forEach(tab => { tab.selected = false });
      this.selectedDiningSlots = data;
      if (isInitial && this.activityService.operation === operationType.create && this.isTimeDropList) {
        this.checkedItem = true;
        this.checkedDiningLocalTime = this.selectedDiningSlots[0];
      }
      this.originalTimeSlotList = data;
      if (this.isEdit && this.activityService.editData?.ReservedFor) {
        this.checkedItem = data && data.findIndex(time => time === this.activityService.editData?.ReservedFor) !== -1 ? true : false;
      } else if (isInitial && this.activityService.sessionFilterValue?.checkedDiningLocalTime) {
        this.checkedItem = data && data.findIndex(time => time === this.activityService.sessionFilterValue.checkedDiningLocalTime) !== 1 ? true : false;
      }
      this.showOtherDaysAvailable();
    })
    );
  }

  getSlotsForClass(requestedObject, isInitial = false, filterChanges = false) {
    requestedObject.PropertyId = this.selectedActivityData.restaurantWidgetId;
    this.checkedItem = false;
    this.activityService.startLoader();
    this.subscriptions.add(this.activityService.GetClassSlots(requestedObject).subscribe(response => {
      this.activityService.stopLoader();
      const slots = response.Payload;
      this.getSlotInitial = false;
      this.afterSlotResponse(slots, isInitial, filterChanges);
    }));
  }


  afterSlotResponse(slots, isInitial = false, filterChanges = false) {
    let restaurantData: any;
    let restaurantId = this.activityService.isDining ? this.activityService.selectedDining.RestaurantId : !this.activityService.isNonDining ? this.activityService.selectedActivities.RestaurantId : this.activityService.selectedNonDining.RestaurantId;
    restaurantData = this.activityService.widgetSettings.PropertyWidgetSettings.find(property => property.RestaurantId == restaurantId);
    this.activityService.addOnList = restaurantData.Addons || [];

    let overAllAddons = Utilities.getAddons(this.activityService.addOnList, this.selectedActivityData?.SpecialMealId);
    let Addons = Utilities.getMandatoryAddons(this.activityService.addOnList, this.selectedActivityData?.SpecialMealId);

    this.sessionSlotsAvailableDates = slots.length ? slots.map((date, index) => {
      if(!this.activityService.editData && !this.activityService.fromConfirmation)
      date.AvailableSessions = date.AvailableSessions.filter(session => session.Availability?.AvailabilityType != AvailabilityType.Cancelled)
     else
    date.AvailableSessions = date.AvailableSessions.filter(session => session.Availability?.AvailabilityType != 6 || ( session.Availability?.AvailabilityType == 6 && _.map(this.activityService.editData.BookedSessions,'ActivitySessionId').includes(session.SessionId)))
      date.AvailableSessions = date.AvailableSessions
        .filter(session => session.Availability?.AvailabilityType !== AvailabilityType.SelectionCriteriaNotMatched)
        .map((slot, datatindex) => {
          slot.Start = date.AvailableDate.split('T')[0] + 'T' + slot.Start;
          slot.End = date.AvailableDate.split('T')[0] + 'T' + slot.End;
          if (this.activityService?.editData && isInitial && !this.activityService?.sessionFilterValue?.currentFromDate) {
            this.updateSlotBasedOnBookedSession(slot, date);
          }
          if (!this.isNotPastTimeSlot(slot.End) && !slot.isChecked) {
            slot.disabled = true;
          }
          if (!this.isNotPastTimeSlot(slot.End)) {
            slot.pastSlot = true;
          }
          if (slot.Availability?.AvailabilityType == AvailabilityType.Blocked) {
            slot.isBlocked = true;
          }
          slot.isAddonAvailable = true;
          this.activityService.selectedSize = this.overAllBookingSize;
          slot.isAddonAvailable = Utilities.filterSlotsbyAddon(this.activityService.addOnList, overAllAddons, Addons, slot.AddOnAvailability, this.overAllBookingSize, this.selectedActivityData?.SpecialMealId);
          slot.showAvailibility = this.seatCountAvailability(slot?.Availability?.AvailabilityType,slot?.Availability?.AvailableSlots, slot.disabled, slot.isAddonAvailable, slot.isBlocked);
          slot.sessionHeadlines = this.getPublicHeadLine(slot);
          if (slot.isChecked)
            this.activityService.selectedSlot = slot;
          return slot;
        }).sort((a, b) => {
          const c: any = new Date(a.Start);
          const d: any = new Date(b.Start);
          return c.getTime() - d.getTime();
        });
      // console.log(date);
      return date;
    }) : [];

    if (this.sessionSlotsAvailableDates) {
      this.showSessionorSlots = true;
      this.sessionSlotsAvailableDates =
        this.sessionSlotsAvailableDates.filter(slot => slot.AvailableSessions.length);
      const isChecked = false;
      this.sessionSlotsAvailableDates.forEach((element, index) => {
        const checked = element.AvailableSessions.findIndex(x => x.isSelected);
        if (checked !== -1 && !this.checkedItem) {
          this.checkedItem = true;
          this.selectedIndex = index;
        }
      });

      this.slotStatusSet();
    }

    if (!this.isSessionClass) {
      this.availableSessions = [];
      this.classLessonList = [];
      this.sessionSlotsAvailableDates.forEach(elm => {
        this.availableSessions = [...this.availableSessions, ...elm.AvailableSessions];
      });
      const groupIdList: any[] = Utilities.uniqueBy(this.availableSessions, 'SessionGroupId');
      groupIdList.forEach(group => {
        const selectedSession = this.availableSessions.find(session => session.SessionGroupId === +group.SessionGroupId);
        selectedSession.isChecked =
          this.activityService.editPartyData$.value && this.activityService.editPartyData$.value.SessionGroupId ?
            selectedSession.SessionGroupId === this.activityService.editPartyData$.value.SessionGroupId : false;
        this.classLessonList.push(selectedSession);
        const checkedItem = this.classLessonList.filter(x => x.isChecked);
        this.checkedItem = checkedItem.length ? true : false;
      });
      this.selectedClassSchedule = [];
      let groupList: any[] = Utilities.uniqueBy(this.availableSessions, 'SessionGroupId', 'DayOfWeek', 'SessionId');
      groupList = groupList.filter(group => group.SessionGroupId === this.activityService.editPartyData$.value?.SessionGroupId);
      groupList.forEach(groupDetail => {
        if (!this.selectedClassSchedule[groupDetail.DayOfWeek]) {
          this.selectedClassSchedule[groupDetail.DayOfWeek] = [];
        }
        const selectedItem = this.availableSessions
          .find(session => session.SessionGroupId === groupDetail.SessionGroupId &&
            session.DayOfWeek === groupDetail.DayOfWeek && session.SessionId === groupDetail.SessionId);
        this.selectedClassSchedule[groupDetail.DayOfWeek].push(selectedItem);
      });
    }
    this.showSessionorSlots = true;

    if (!filterChanges && this.activityService?.sessionFilterValue?.sessionSlotsAvailableDates?.length) {
      this.sessionSlotsAvailableDates?.[this.selectedIndex]?.AvailableSessions?.forEach((element, index) => {
        const checkedSessionObj =
          this.activityService?.sessionFilterValue?.sessionSlotsAvailableDates?.[this.selectedIndex]?.AvailableSessions
            .find(x => x.SessionId === element.SessionId);
        if (Object.keys(checkedSessionObj)?.length && checkedSessionObj.isChecked) {
          element.isChecked = true;
          this.checkedItem = true;
        }
      });
    }
  }

  getPublicHeadLine(slot: any) {
    let description: string = '';
    if (this.activityHeadlines == null || this.activityHeadlines?.length == 0) {
      return;
    }
    else {
      const sessionStart = moment(slot.Start).format("YYYY-MM-DD");
      const sessionHeadlines = this.activityHeadlines.filter(x => x.ActivitySessionId == slot.SessionId && x.AttributeType == AttributeType.PublicHeadlines
        && moment(x.StartDate).format("YYYY-MM-DD") == sessionStart);
      if (sessionHeadlines != null && sessionHeadlines.length > 0) {
        description = sessionHeadlines[0].Description;
      }
      if (sessionHeadlines == null || sessionHeadlines.length == 0) {
        const activityId = this.selectedActivityData?.Id;
        const openHeadlines = this.activityHeadlines.filter(x => x.ActivityId == activityId && x.AttributeType == AttributeType.PublicHeadlines && x.ApplyForAllSessions && !x.IsDefault
          && moment(x.StartDate).format("YYYY-MM-DD") == sessionStart);
        if (openHeadlines != null && openHeadlines.length > 0) {
          description = openHeadlines[0].Description;
        }
        if (openHeadlines == null || openHeadlines.length == 0) {
          const publicHeadlines = this.activityHeadlines.filter(x => x.ActivityId == activityId && x.AttributeType == AttributeType.PublicHeadlines && x.IsDefault);
          if (publicHeadlines != null && publicHeadlines.length > 0) {
            description = publicHeadlines[0].Description;
          }
        }
      }
    }
    return description;
  }

  seatCountAvailability(availabilityType: number, seatLeftCount: number, isDisabled: boolean, isAddonAvailable: boolean, isBlocked: boolean) {
    const countMultiplier = this.selectedActivityData?.SlotCountInWidget && this.selectedActivityData?.SlotCountInWidget > 0 ? this.selectedActivityData?.SlotCountInWidget : 0;
    if(availabilityType == AvailabilityType.Cancelled){
      return { status: SessionAvailabiltyStatus.NotAvailable, text: this.ts.instant('Cancelled') };
    }
    if (isBlocked) {
      return { status: SessionAvailabiltyStatus.Blocked, text: this.ts.instant('currentlyUnavailable') };
    }
    if (countMultiplier > 0 && isDisabled) {
      return { status: SessionAvailabiltyStatus.PastTime, text: '' };
    }
    if (countMultiplier > 0 && seatLeftCount > this.selectedActivityData.MaxPartySize * countMultiplier) {
      return { status: SessionAvailabiltyStatus.Available, text: '' };
    }
    if (countMultiplier > 0 && seatLeftCount > this.selectedActivityData.MaxPartySize && seatLeftCount <= this.selectedActivityData.MaxPartySize * countMultiplier) {
      return { status: SessionAvailabiltyStatus.LimitedAvailability, text: this.ts.instant('limitedAvailablity') };
    }
    if (seatLeftCount === 0) {
      return { status: SessionAvailabiltyStatus.NotAvailable, text: this.ts.instant('soldOut') };
    }

    if (seatLeftCount > 0 && !isAddonAvailable) {
      return { status: SessionAvailabiltyStatus.NotAvailable, text: '' };
    }
    return { status: SessionAvailabiltyStatus.LessAvailability, text: seatLeftCount + ' ' + this.ts.instant('left') };
  }

  slotChangeListners(event) {
    if (event.disabled || event.disabledOverlaped || !event.isAddonAvailable) {
      return false;
    }
    event.isChecked = !event.isChecked;
    if (this.isMultiSlotSelection) {
      this.disableOverlapingSessions();
    }
    this.activityService.selectedSlot = event;
    if (this.selectedActivityData && this.selectedActivityData.ClassType === ClassType.Class && event.isChecked) {
      let groupIdList: any[] = Utilities.uniqueBy(this.availableSessions, 'SessionGroupId', 'DayOfWeek', 'SessionId');
      this.selectedClassSchedule = [];
      groupIdList = groupIdList.filter(group => group.SessionGroupId === event.SessionGroupId);
      groupIdList.forEach(groupDetail => {
        if (!this.selectedClassSchedule[groupDetail.DayOfWeek]) {
          this.selectedClassSchedule[groupDetail.DayOfWeek] = [];
        }
        const selectedItem = this.availableSessions.
          find(session => session.SessionGroupId === groupDetail.SessionGroupId &&
            session.DayOfWeek === groupDetail.DayOfWeek && session.SessionId === groupDetail.SessionId);
        this.selectedClassSchedule[groupDetail.DayOfWeek].push(selectedItem);
      });
      this.classLessonList.forEach(session => {
        if (session.SessionId !== event.SessionId || session.SessionGroupId !== event.SessionGroupId) {
          session.isChecked = false;
        }
      });
      const checkedItem = this.classLessonList.filter(x => x.isChecked);
      this.checkedItem = checkedItem.length ? true : false;
    } else if (!this.isMultiSlotSelection && event.isChecked) {
      let isChecked = false;
      this.sessionSlotsAvailableDates.forEach((element, index) => {
        element.AvailableSessions.forEach(session => {
          if (session.SessionId !== event.SessionId) {
            session.isChecked = false;
          }
          if (session.isChecked) {
            isChecked = true;
          }
        });
      });
      this.checkedItem = isChecked;
    } else {
      if (this.classLessonList && this.classLessonList.length > 0) {
        const checkedItem = this.classLessonList.filter(x => x.isChecked);
        this.checkedItem = checkedItem.length ? true : false;
      } else {
        let isChecked = false;
        this.sessionSlotsAvailableDates.forEach((element, index) => {
          element.AvailableSessions.forEach(session => {
            if (session.isChecked) {
              isChecked = true;
            }
          });
        });
        this.checkedItem = isChecked;
      }
    }
  }

  diningSlotChangeListners(event) {
    this.checkedDiningLocalTime = (!this.isTimeDropList && this.checkedDiningLocalTime === event) ? '' : event ? event : this.checkedDiningLocalTime;
    this.checkedItem = this.checkedDiningLocalTime === '' ? false : true;
    this.isValidFormValues();
  }

  updateSlotBasedOnBookedSession(slot, date) {
    const editData = this.activityService.editData;
    slot.isChecked = editData && editData.BookedSessions && editData.BookedSessions.length > 0 &&  !_.map(this.activityService.editData.SpecialMeal.ActivitySessions.filter(data => data.StatusCode == Status.Cancelled),'ActivitySessionId').includes(slot.SessionId)? 
      this.isSlotBooked(date.AvailableDate, slot.SessionId, editData) : false;

    if (slot.isChecked && editData && editData.BookedSessions && editData.BookedSessions.length > 0 &&
      this.getStateOfBookedSession(date.AvailableDate, slot.SessionId, editData) === PartyState.Seated) {
      slot.Availability.AvailabilityType = AvailabilityType.SelectionCriteriaNotMatched;
      slot.isChecked = false;
    }

    if (slot.isChecked) {
      this.checkedItem = true;
    }
  }

  isSlotBooked(date, sessionId, editData): boolean {
    return editData.BookedSessions.
      findIndex(session =>
        moment(session.BookedDate).
          diff(moment(date), 'days') === 0 && session.ActivitySessionId === sessionId
        && session.SessionState !== PartyState.Cancelled) > -1;
  }

  isNotPastTimeSlot(slotDateTime): boolean {
    const currentTime =
      Utilities.getRestaurantDateTime(this.activityService?.selectedActivities?.DaylightDelta);
    const past1hr = new Date(currentTime.valueOf());
    const slotTime = Utilities.parseDateString(slotDateTime);
    return slotTime >= past1hr;
  }

  getStateOfBookedSession(date, sessionId, editData): PartyState {
    return editData.BookedSessions.
      find(session => moment(session.BookedDate).
        diff(moment(date), 'days') === 0 && session.ActivitySessionId === sessionId).SessionState;
  }

  calculatePartySize() {
    this.bookingSizeArray = [];
    for (let i = 1; i <= this.selectedActivityData?.MaxPartySize; i++) {
      this.bookingSizeArray.push({ id: i, value: i.toString() });
    }
    // this.bookingSizeArray.push({ id: this.maxSizeAllowed, value: this.maxSizeAllowed.toString() + "+" });
    return this.bookingSizeArray;
  }

  loadPreviousDate(index) {
    if (index === 0) {
      return false;
    }
    this.selectedIndex -= 1;
    this.slotStatusSet();
  }

  loadNextDate(index) {
    if (index === (this.sessionSlotsAvailableDates.length - 1)) {
      return false;
    }
    this.selectedIndex += 1;
    this.slotStatusSet();
  }

  slotStatusSet() {
    const membershipId = this.activityService.membershipId || null;
    if (this.sessionSlotsAvailableDates) {
      this.sessionSlotsAvailableDates[this.selectedIndex]?.AvailableSessions.forEach(session => {
        let isAnyMember = false;
        isAnyMember = this.IsMember(session.Availability);
        session.disabled = session.disabled || !(session.Availability?.AvailabilityType === AvailabilityType.OpenToAll
          || (session.Availability?.AvailabilityType === AvailabilityType.OpenToSpecificMember
            && session.Availability?.AllocationTypeId === membershipId && this.activityService.selectedGuest.MemberActive
            || (isAnyMember && membershipId)) || session.isChecked) || (session.Availability?.AvailabilityType === AvailabilityType.Cancelled);
        if (session.Availability?.AllocationTypeId) {
          const { R, G, B, A } = session.AllocationTypes?.
            find(type => type.AllocationTypeId === session.Availability?.AllocationTypeId)?.Color;
          session.color = `rgba(${R}, ${G}, ${B}, ${A})`;
        }
      });
      this.disableOverlapingSessions();
    }
  }

  disableOverlapingSessions() {
    const selectedSlots = this.sessionSlotsAvailableDates[this.selectedIndex]?.AvailableSessions.filter(slot => slot.isChecked);
    this.sessionSlotsAvailableDates[this.selectedIndex]?.AvailableSessions.forEach(session => {
      if (!session.isChecked && this.isMultiSlotSelection) {
        session.disabledOverlaped = this.isOverlap(selectedSlots, session);
      }
    });
  }

  isBetween(start, end, value) {
    return value > start && value < end;
  }

  isOverlap(selectedSlots, slot): boolean {
    const slotStart = new Date(slot.Start);
    const slotEnd = new Date(slot.End);

    const intersectingSlots = selectedSlots.filter(selectedSlot => {
      const selectedSlotStart = new Date(selectedSlot.Start);
      const selectedSlotEnd = new Date(selectedSlot.End);

      if ( // is Same Start Or End
        slotStart.getTime() === selectedSlotStart.getTime() ||
        slotEnd.getTime() === selectedSlotEnd.getTime() ||
        // is slot falls between selectedSlot
        this.isBetween(selectedSlotStart, selectedSlotEnd, slotStart) ||
        this.isBetween(selectedSlotStart, selectedSlotEnd, slotEnd) ||
        // is selectedSlot falls between slot
        this.isBetween(slotStart, slotEnd, selectedSlotStart) ||
        this.isBetween(slotStart, slotEnd, selectedSlotEnd)) {
        return true;
      }

      return false;
    });
    return intersectingSlots.length;
  }

  storeFilters() {
    this.activityService.sessionFilterValue = {};
    this.activityService.sessionFilterValue.coverTypes = this.coverTypes;
    this.activityService.sessionFilterValue.bookingTypes = this.bookingTypes;
    this.activityService.sessionFilterValue.currentFromDate = this.currentFromDate;
    this.activityService.sessionFilterValue.currentToDate = this.currentToDate;
    this.activityService.sessionFilterValue.currentBookingSize = this.currentBookingSize;
    this.activityService.sessionFilterValue.sessionSlotsAvailableDates = JSON.parse(JSON.stringify(this.sessionSlotsAvailableDates));
    this.activityService.sessionFilterValue.selectedIndex = this.selectedIndex;
    this.activityService.sessionFilterValue.selectedSeatingArea = this.selectedSeatingArea;
    this.activityService.sessionFilterValue.selectedSeatingType = this.selectedSeatingType;
    this.activityService.sessionFilterValue.isCommunalTable = this.isCommunalTable;
    this.activityService.sessionFilterValue.marketingFlag = this.marketingFlag;
    this.activityService.sessionFilterValue.selectedSpecialMealId = this.selectedActivityData?.Id;
    this.activityService.sessionFilterValue.checkedDiningLocalTime = this.checkedDiningLocalTime;
    this.activityService.sessionFilterValue.checkedNonDiningLocalTime = this.checkedNonDiningLocalTime;
    this.activityService.sessionFilterValue.isSpecialMealReservation = this.showSpecialEvent;
    this.activityService.sessionFilterValue.notes = JSON.parse(JSON.stringify(this.notesOptions));
    this.activityService.sessionFilterValue.marketingFlag = this.marketingFlag;
    this.activityService.sessionFilterValue.promoCodeDetail = this.promoCodeDetail;
  }

  getCoverTypeValues() {
    const formatedCoverTypes = [];
    this.coverTypes.forEach(coverType => {
      if(coverType.name || coverType.Name)
      formatedCoverTypes.push({ Covers: coverType.value, CoverTypeId: coverType.id, Name: coverType.name || coverType.Name, Price: coverType?.price });
    });
    return formatedCoverTypes;
  }

  getFormattedCoverTypeValues() {
    const formatedCoverTypes = [];
    this.coverTypes.forEach(coverType => {
      formatedCoverTypes.push({ value: +coverType?.Covers || +coverType?.value, id: coverType?.CoverTypeId || coverType?.id, name: coverType?.CoverTypeName || coverType?.name, price: coverType?.Price });
    });
    this.coverTypes = formatedCoverTypes;
  }

  getFormattedBookingTypeValues() {
    const formatedBookingTypes = [];
    this.bookingTypes.forEach(bookType => {
      formatedBookingTypes.push(
        { value: +bookType?.BookingTypes, id: bookType?.BookingTypeId, name: bookType?.Name }
      );
    });
    this.bookingTypes = formatedBookingTypes;
  }

  getBookingTypeValues() {
    const formatedBookingTypes = [];
    this.bookingTypes.forEach(bookType => {
      formatedBookingTypes.push(
        { BookingTypes: bookType.value, BookingTypeId: bookType.id, Name: bookType.name }
      );
    });
    return formatedBookingTypes;
  }

  getSlotsObj() {
    const resSlots = [];
    this.selectedTimeSlots = [];

    this.sessionSlotsAvailableDates.forEach(availableDate => {

      let sessionsSelected = availableDate.AvailableSessions
        .filter(session => session.isChecked);
      sessionsSelected.forEach(element => {
        this.selectedTimeSlots.push({
          SessionId: element.SessionId,
          Start: element.Start,
          End: element.End,
          Date: availableDate.AvailableDate
        });
      });
      sessionsSelected = sessionsSelected.map(session => session.SessionId);

      if (sessionsSelected.length) {
        resSlots.push({ Date: availableDate.AvailableDate, SessionIds: sessionsSelected });
      }
    });
    return resSlots;
  }

  getSessionGroupId() {
    if (!this.isSessionClass) {
      if (!this.selectedClassSchedule.length && this.selectedActivityData) {
        return this.selectedActivityData.SessionGroupId;
      } else if (this.selectedClassSchedule.length) {
        return this.selectedClassSchedule.find(item => item)[0].SessionGroupId;
      }
    }
    return null;
  }

  isCheckCartExisting() {
    let alreadyExist = -1;
    const cartObj = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);

    cartObj.forEach((eachItem, index) => {
      if (eachItem.isDining || eachItem.isNonDining) {
        if (new Date(this.currentFromDate).toDateString() === new Date(eachItem.LocalTime).toDateString()
          && ((this.showSpecialEvent && eachItem.LocalTime === this.checkedDiningLocalTime && eachItem?.SpecialMealId === this.selectedActivityData?.Id)
            || (!this.showSpecialEvent && eachItem.LocalTime === this.checkedDiningLocalTime && !eachItem?.SpecialMealId))) {
          alreadyExist = index;
        }
      } else {
        const checkedItems = [];
        this.sessionSlotsAvailableDates.forEach(availableDate => {
          const sessionsSelected = availableDate.AvailableSessions
            .filter(session => session.isChecked);
          sessionsSelected.forEach(element => {
            checkedItems.push(element.SessionId);
          });
        });
        console.log(checkedItems);
        console.log(eachItem.SelectedTimeSlots[0].SessionId);
        if (checkedItems.indexOf(eachItem.SelectedTimeSlots[0].SessionId) !== -1) {
          alreadyExist = index;
        }
      }
    });

    return alreadyExist;
  }

  addToCart(continueClicked = false) { // For adding To Cart
    if(!this.addToCartEnableForTaxType){
      this.addtoCartValidation(this.ts.instant('addToCartValidationMsg'));
      return;
    }
    this.storeFilters();
    console.log(this.notesOptions);
    const updateCartIndex = this.isCheckCartExisting();
    this.setBookingData();
    if (this.isEdit) {
      this.activityService.SaveBookingObj.Id = this.activityService.editData.Id;
      this.guestContactValidation = false;
      this.activityService.validateCartItem(this.activityService.SaveBookingObj).subscribe(data => {
        this.guestContactValidation = true;
        if (data?.ValidationMessages.filter(msg => msg.Type == ValidationMessageType.Error).length === 0 && !data?.ExceptionMessage) {
          this.validateCartItemApiSuccessHandler(continueClicked, updateCartIndex);
        } else {
          this.bookingErrorHandler(data?.ExceptionMessage
            || data?.ValidationMessages?.filter(msg => msg.Type == ValidationMessageType.Error)[0]?.Message
            || this.ts.instant('errorWhileCreatingReservation'), (data?.ValidationMessages || []), continueClicked, updateCartIndex);
        }
      });
    }
    else {
      this.guestContactValidation = false;
      if(this.activityService.SaveBookingObj?.Contact){
        sessionStorage.setItem('guest_contact' , JSON.stringify(this.activityService.SaveBookingObj.Contact));
      }
      this.activityService.validateCartItem(this.activityService.SaveBookingObj).subscribe(data => {
        this.guestContactValidation = true;
        this.proceedAddToCart(continueClicked, updateCartIndex);
        if (continueClicked) {
          this.activityService.lockMultiPropertySessionsfn(this.activityService.restaurantMerchantCode);
        }
        else {
          this.activityService.navigateToPage();
        }
      });
    }
  }

  validateCartItemApiSuccessHandler(continueClicked, updateCartIndex) {
    this.proceedAddToCart(continueClicked, updateCartIndex);
    this.activityService.lockMultiPropertySessionsfn(this.activityService.restaurantMerchantCode);
    this.finishReservationClicked = false;
  }

  bookingErrorHandler(errorText: string, ValidationMessages: any[], continueClicked, updateCartIndex) {

    const isOverlapBookError = ValidationMessages?.filter(x => x.Type == 2).length ? true : false;
    if (isOverlapBookError) {
      errorText = ValidationMessages.find(x => x.Type == 2)?.Message || this.ts.instant('errorWhileCreatingReservation');
    }

    const popUpMessage = [{
      confirmationMessage: errorText,
      dialogTitle: this.ts.instant('warningText'),
      showAlert: true,
      isScrolable: true
    }];
    const height = '330px';
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    const bookingErrorDialogRef = this.activityService.openCustomPopup(componentDetails, ComponentTypes.clearCart, '400px', height, true, '',
      this.getErrorDialogPrimaryBtnLabel(isOverlapBookError), this.getErrorDialogSecondryBtnLabel(isOverlapBookError), true, '90vw');
    bookingErrorDialogRef.afterClosed().subscribe(data => {
      if (data.ok && !isOverlapBookError) {
        this.activityService.navigateToUrl('list');
      } else if (data.ok && isOverlapBookError) {
        this.activityService.bShowOverbookingErrorDialog = true;
        this.validateCartItemApiSuccessHandler(continueClicked, updateCartIndex);
        return;
      }
      this.activityService.bShowOverbookingErrorDialog = false;
    });
  }

  getErrorDialogPrimaryBtnLabel(isOverlapBookError: boolean) {
    if (isOverlapBookError)
      return this.ts.instant('Yes');
    else if (this.isEdit)
      return this.ts.instant('retryUpdate');
    else
      return this.ts.instant('bookAgain');
  }

  getErrorDialogSecondryBtnLabel(isOverlapBookError: boolean) {
    if (isOverlapBookError)
      return this.ts.instant('No');
    else
      return this.ts.instant('cancel');
  }

  proceedAddToCart(continueClicked, updateCartIndex) {
    let cartObj = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);
    let cartLockObj = this.activityService.getSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, true);
    if (updateCartIndex >= 0) {
      const sessionFromCart = JSON.parse(JSON.stringify(cartObj[updateCartIndex]));
      delete sessionFromCart.Slot?.LockId;
      delete sessionFromCart.Sessions?.LockId;
      const saveBookingObj = JSON.parse(JSON.stringify(this.activityService.SaveBookingObj));
      delete saveBookingObj.Slot?.LockId;
      delete saveBookingObj.Sessions?.LockId;
      if (JSON.stringify(sessionFromCart) === JSON.stringify(saveBookingObj)) {
        if (!continueClicked) {
          this.activityService.
            openSnackBar(this.ts.instant('itemAlreadyinCart'),
              this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
        }
        return false;
      }
      cartObj[updateCartIndex] = this.activityService.SaveBookingObj;
      cartLockObj[updateCartIndex] = this.activityService.SessionBookingObj;
    } else {
      if (cartLockObj?.length && cartObj?.length) {
        cartObj.push(this.activityService.SaveBookingObj); // this is used for bookink obj payload
        cartLockObj.push(this.activityService.SessionBookingObj); // this is used for cartLock payload
      } else {
        cartObj = [];
        cartLockObj = [];
        cartObj.push(this.activityService.SaveBookingObj);
        cartLockObj.push(this.activityService.SessionBookingObj);
      }
    }
    this.activityService.setSessionData('CartList_' + this.activityService.restaurantMerchantCode, cartObj, true);
    this.activityService.setSessionData('CartLockList_' + this.activityService.restaurantMerchantCode, cartLockObj, true);
    this.activityService.getCartCount();
    let isDining = this.activityService.isDining;
    if (this.activityService.operation !== operationType.edit) {
      this.activityService.
        openSnackBar(updateCartIndex === -1 ? this.ts.instant(isDining ? 'diningaddedToCartSuccessfully' : 'addedToCartSuccessfully') :
          this.ts.instant(isDining ? 'diningupdatedToCartSuccessfully' : 'updatedToCartSuccessfully'),
          this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
    }
    const crypto = window.crypto;
    const array = new Uint32Array(1);
    this.activityService.CartBookingList$.next(crypto.getRandomValues(array));
    this.uncheckSelectedSession();
    this.resetNotes();
    this.activityService.showGuestFields = false;
  }

  setBookingData() {
    this.activityService.SessionBookingObj = new SessionBookingDTO(
      null,
      this.selectedActivityData?.SpecialMealId || this.activityService?.editData?.SpecialMealId ||null,
      this.selectedActivityData?.ClassType || 0,
      this.currentFromDate,
      this.currentToDate,
      (this.activityService.isDining || !this.currentLocations) ? this.currentLocations : (typeof (this.currentLocations) == 'object' ? this.currentLocations : [this.currentLocations]),
      [this.activityService.isDining ? this.activityService.selectedDining.LocationName : this.activityService.selectedNonDining.LocationName],
      (this.activityService.isDining || !this.currentInstructors) ? this.currentInstructors : (typeof (this.currentInstructors) == 'object' ? this.currentInstructors : [this.currentInstructors]),
      this.overAllBookingSize,
      '',
      this.getCoverTypeValues(),
      this.getBookingTypeValues(),
      this.getSlotsObj(),
      this.getSessionGroupId(),
      !this.activityService.isDining && !this.activityService.isNonDining ? this.activityService.selectedActivities.restaurantWidgetId : !this.activityService.isNonDining ? this.activityService.selectedDining.RestaurantId : this.activityService.selectedNonDining.RestaurantId,
      this.selectedSeatingArea || this.selectedSeatingArea == 0 ? (!this.activityService.isNonDining ? this.selectedSeatingArea : this.getOpenBookingSelectedSeatingArea()) : null,
      this.selectedSeatingType || this.selectedSeatingType == 0 ? (!this.activityService.isNonDining ? this.selectedSeatingType : this.getOpenBookingSelectedSeatingType()) : null,
      this.activityService.isDining ? this.checkedDiningLocalTime : this.checkedNonDiningLocalTime,
      this.isCommunalTable
    );
    this.activityService.SessionBookingObj.CartId = (Utilities.getRandomDecimal() + 1).toString(36).substring(7);
    if (!this.isSessionClass) {
      this.activityService.SelectedClassSchedule$.next(this.selectedClassSchedule);
    }
    if (this.isEdit && this.activityService.editData?.Notes) {
      this.activityService.SessionBookingObj.Notes = this.activityService.editData.Notes;
    }
    this.activityService.SessionBookingObj.AvailabilityCriteria =
      this.getAvailabilityCriteria(this.currentLocations, this.currentInstructors);
    this.createSaveRequestObject();
  }

  createSaveRequestObject() {
    const bookingData = this.activityService.SessionBookingObj;
    var ContactObj = {} as FullContactDTO;
    ContactObj = Object.assign(ContactObj, this.guestContact);
    if (this.noteType === NoteType.guestNote) {
      ContactObj.Notes = this.getCategoryPreferencesNotes(NoteType.guestNote, this.notesOptions);
    }
    if (!ContactObj.MarketingOptedIn) {
      ContactObj.MarketingOptedIn = this.activityService.isDining ? this.marketingFlag : null;
    }
    if (this.guestContact.SecondaryContactsList?.length) {
      this.guestContact.SecondaryContactsList?.map(x => {
        x.Notes = this.getCategoryPreferencesNotes(NoteType.guestNote, x.Notes);
      });
      ContactObj.SecondaryContactsList = this.guestContact.SecondaryContactsList;
    }
    console.log(this.selectedActivityData)
    let currentEditItem: any = {};
    currentEditItem = !this.activityService.isDining && !this.activityService.isNonDining
      ? this.activityService?.selectedActivities : !this.activityService.isDining ? this.activityService?.selectedNonDining : this.activityService?.selectedDining;
    let bookingTypeDetails = {} as BookingTypeInfo;
    bookingTypeDetails.BookingGuestType = this.selectedBookingType;
    bookingTypeDetails.Input = this.confirmationNumber;

    this.activityService.SaveBookingObj = {
      CartId: (Utilities.getRandomDecimal() + 1).toString(36).substring(7),
      Id: this.isEdit ? this.activityService.editData?.Id : null,
      Size: bookingData.BookingSize,
      RemindAboutVisit: false,
      RemindAboutVisitEmail: false,
      AgreedWithTermsOfUse: true,
      Contact: ContactObj,
      Slots: !this.activityService.isNonDining ? this.getSlotsObj() : this.getOpenBookingSlots(),
      Slot: !this.activityService.isNonDining ? this.getRequestObjectSlot() : (this.getOpenBookingSlots()[0] || {}),
      Sessions: !this.activityService.isNonDining ? this.getRequestObjectSlots() : null,
      PartyId: null,
      SeatingAreaId: this.selectedSeatingArea || null,
      SeatingTypeId: this.selectedSeatingType || null,
      LocalTime: this.activityService.isNonDining ? this.checkedNonDiningLocalTime : this.checkedDiningLocalTime,
      SeatingTime: this.activityService.isNonDining ? this.checkedNonDiningLocalTime : this.checkedDiningLocalTime,
      isDining: this.activityService.isDining,
      isNonDining: this.activityService.isNonDining,
      Notes: this.noteType === NoteType.partyNote ? this.getCategoryPreferencesNotes(NoteType.partyNote, this.notesOptions) : this.getNotes(),
      TableIds: !this.activityService.isNonDining ? bookingData.Location : this.activityService.selectedNonDiningLocation.map(({ Id }) => (Id)),
      InstructorIds: bookingData.StaffId,
      CoverTypes: this.sizeMapping?.sizes || bookingData.GuestTypes,
      BookingTypes: bookingData.BookingTypes,
      IsCommunalTable: this.isCommunalTable,
      FromWebsite: true,
      Language: 0,
      ReservationAttemptId: null,
      waiverFormTransactionId: null,
      BookingContacts: this.guestContact?.SecondaryContactsList?.length ? this.guestContact.SecondaryContactsList : null,
      BookingBehavior: !this.activityService.isDining && !this.activityService.isNonDining ? BookingBehavior.ClassOrSession : BookingBehavior.OpenBooking,
      SpecialMealId: bookingData.ActivityId,
      StaffId: bookingData.StaffId,
      StaffIds: bookingData.StaffId,
      StartDate: !this.activityService.isDining && !this.activityService.isNonDining ? (moment(bookingData.FromDate).format()).split('+')[0] : this.activityService.isNonDining ? (moment(this.checkedNonDiningLocalTime).format()).split('+')[0] : null,
      EndDate: !this.activityService.isDining && !this.activityService.isNonDining ? (moment(bookingData.ToDate).format()).split('+')[0] : this.activityService.isNonDining ? (moment(this.checkedNonDiningLocalTime).format()).split('+')[0] : null,
      SelectedSchedule: this.selectedClassSchedule,
      SelectedTimeSlots: this.selectedTimeSlots,
      SessionGroupId: bookingData.SessionGroupId,
      SelectedActivityInfo: this.getSelectedItemInfo(currentEditItem),
      PropertyId: !this.activityService.isDining && !this.activityService.isNonDining ? this.activityService.selectedActivities.restaurantWidgetId : !this.activityService.isNonDining ? this.activityService.selectedDining.RestaurantId : this.activityService.selectedNonDining.RestaurantId,
      AllowAdditionalGuest: !this.activityService.isDining && !this.activityService.isNonDining ? this.selectedActivityData?.AllowAdditionalGuestDetails : currentEditItem.WidgetCustomization?.ConfirmationVia,
      DoesRequirePrepayment: this.selectedActivityData?.DoesRequirePrepayment,
      Price: this.selectedActivityData?.Price,
      ConfirmationVia: !this.activityService.isDining && !this.activityService.isNonDining ? this.activityService?.selectedActivities?.ConfirmationVia : !this.activityService.isNonDining ? this.activityService?.selectedDining?.ConfirmationVia : this.activityService?.selectedNonDining?.ConfirmationVia,
      AddOns: Utilities.getSelectedAddOns(this.activityService.addOnList),
      isBookingApiRequest: true,
      BookingTypeInfo :bookingTypeDetails
      
      // selectedNonDiningLocation: this.activityService.selectedNonDiningLocation[0]
    };

    if (this.activityService.SaveBookingObj?.isNonDining && this.activityService.SaveBookingObj?.TableIds?.length) {
      this.activityService.SaveBookingObj.UserSelectedTable = true;
    }
  }

  getSelectedItemInfo(currentEditItem) {
    return {
      ActivityTypeId: this.selectedActivityData?.ActivityTypeId,
      Name: this.selectedActivityData?.Name,
      OperationCurrency: !this.activityService.isDining ? this.selectedActivityData?.OperationCurrency : currentEditItem?.OperationCurrency,
      CustomTermsOfService: !this.activityService.isDining ? this.selectedActivityData?.WidgetCustomization?.CustomTermsOfService : currentEditItem.WidgetCustomization?.CustomTermsOfService,
      IsSmsReminderSupported: !this.activityService.isDining ? this.selectedActivityData?.IsSmsReminderSupported : currentEditItem?.IsSmsReminderSupported,
      IsReservationReminderMandatory: !this.activityService.isDining ? this.selectedActivityData?.IsReservationReminderMandatory : currentEditItem.WidgetCustomization?.IsReservationReminderMandatory,
      ConfirmationVia: !this.activityService.isDining ? this.selectedActivityData?.ConfirmationVia : currentEditItem.WidgetCustomization?.ConfirmationVia,
      RestaurantName: currentEditItem.RestaurantName
    };
  }

  getRequestObjectSlots() {
    const bookingData = this.activityService.SessionBookingObj;
    const sessionClass = this.activityService.SessionBookingObj.ClassType === ClassType.Session;

    return {
      LockId: this.lockResponse?.SlotLockIdDTO?.Id,
      Sessions: sessionClass ? bookingData.Slots : [],
      SessionGroupId: sessionClass ? null : bookingData.SessionGroupId
    };
  }

  getRequestObjectSlot() {
    const bookingData: SessionBookingDTO = this.activityService.SessionBookingObj;

    return {
      Time: (moment(bookingData.FromDate).format()).split('+')[0],
      LockId: this.lockResponse?.SlotLockIdDTO?.Id,
      Type: !this.activityService.isDining ? bookingData.AvailabilityCriteria : 4
    };
  }

  addtoCartValidation(Message: string) {
    const popUpMessage = [{
      confirmationMessage: Message,
      dialogTitle: '',
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    let addtoCartValidation = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '300px', true, 'No', 'Ok',
      'Cancel', false)
  }

  proceedMultiBooking(continueClicked = false) {
    if(!this.addToCartEnableForTaxType){
      this.addtoCartValidation(this.ts.instant('addToCartValidationMsg'));
      return;
    }
    if (this.finishReservationClicked) {
      return;
    }
    this.finishReservationClicked = true;
    if (this.activityService.operation === operationType.edit) {
      this.activityService.emptyCartData();
    }
    if (!this.checkedItem && this.activityService.getCartCount() === 0) {
      this.activityService.
        openSnackBar(this.ts.instant('addItemstoCarttoProceed'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      this.finishReservationClicked = false;
      return false;
    }
    if (this.checkedItem) {
      this.addToCart(continueClicked);
    }
  }

  lockMultiPropertySessions() {
    const modifiedLockCart = this.activityService.formCartLockPayLoad(this.activityService.restaurantMerchantCode);
    this.activityService.startLoader();
    this.subscriptions.add(
      this.activityService
        .lockMultiPropertySessions(modifiedLockCart).subscribe(response => {
          this.activityService.stopLoader();
          this.activityService.lockMultipleResult = response.Payload;
          this.activityService.setLockIdsResponse(response.Payload, this.activityService.restaurantMerchantCode);
          this.activityService.operation === operationType.edit ? this.activityService.navigateToUrl('order-summary/edit/' + this.activityService.restaurantWidgetId) : this.activityService.navigateToUrl('order-summary');
        })
    );
  }

  unLockMultiCart(CartLockList , modifiedLockCart) {
    if (modifiedLockCart?.length > 0 && CartLockList.length > 0) {
      this.activityService.startLoader();
      this.subscriptions.add(
        this.activityService
          .unLockMultiPropertySessions(modifiedLockCart).subscribe(response => {
            this.activityService.stopLoader();
            this.activityService.lockMultipleResult = null;
            this.checkDataPresent();
          }, err => {
            this.activityService.stopLoader();
          })
      );
    }
  }
  setNotesData(notesData) {
    this.toggleSelection(notesData.chip, notesData.noteOptions)
  }

  toggleSelection(chip: MatChip, noteOptions) {
    noteOptions.selected = !noteOptions.selected;
    chip.toggleSelected();
  }

  addCategoryPreferencesNotes(noteType: NoteType, notes?, isSecondary?: boolean) {
    let notesData = [];

    let notesPreferencesCategories = [];
    let restaurantId = 0;

    notesPreferencesCategories = !this.activityService.isDining && !this.activityService.isNonDining ? this.activityService?.selectedActivities?.PreferencesCategories
      : this.activityService.isNonDining ? this.activityService?.selectedNonDining?.PreferencesCategories : this.activityService?.selectedDining?.PreferencesCategories;
    restaurantId = !this.activityService.isDining && !this.activityService.isNonDining ? this.selectedActivityData?.restaurantWidgetId
      : this.activityService.isNonDining ? this.activityService.selectedNonDining?.RestaurantId : this.activityService.selectedDining?.RestaurantId;

    if (restaurantId && notesPreferencesCategories && notesPreferencesCategories.length > 0) {
      notesPreferencesCategories.forEach(category => {
        if (category.IncludeInWebReservation) {
          let predefinedNotes = [];
          let freeTextIdValue;
          if (category.SubCategories && category.SubCategories.length > 0) {
            category.SubCategories.forEach(x => {
              let predefinedNoteOptions = noteType === NoteType.guestNote ? x?.PredefinedContactNote : x?.PredefinedPartyNote;
              if (predefinedNoteOptions) {
                predefinedNoteOptions.forEach(note => {
                  if (note.Text.toLowerCase() === "others") {
                    freeTextIdValue = note.Id;
                    this.freeTextIdList.push(freeTextIdValue);
                  } else {
                    let noteMappingList = noteType === NoteType.guestNote ? note.PredefinedContactNotePropertyMapping : note.PredefinedPartyNotePropertyMapping;
                    noteMappingList = noteMappingList.filter(x => x.PropertyId === restaurantId).map(x => noteType === NoteType.guestNote ? x.PredefinedContactNoteId : x.PredefinedPartyNoteId);
                    if (noteMappingList.find(x => x === note.Id)) { predefinedNotes.push(note) }
                  }
                });
              }
              this.freeTextIdList = [...new Set(this.freeTextIdList)];
            })
          };
          let inputOptions: any = {};
          if (predefinedNotes && predefinedNotes.length > 0) {
            inputOptions.text = predefinedNotes[0]?.Category;
            inputOptions.checkBoxOptions = predefinedNotes.map(x => { return { id: x.Id, value: x.Text, selected: false, icon: x.Icon } });
            if (freeTextIdValue) {
              inputOptions.commentsBox = {
                id: freeTextIdValue,
                value: ''
              }
            }
            if (this.activityService.operation === operationType.edit && notes?.length > 0) {
              let noteEditData = noteType == NoteType.partyNote ? this.activityService.editData.Notes : this.activityService.editData.Contact.Notes;
              if (isSecondary) {
                noteEditData = notes;
              }
              noteEditData?.forEach(note => {
                if (note.Type == PartyNoteType.PromoCode && note.Text) {
                  this.promoCodeDetail = note.Text;
                }
                inputOptions.checkBoxOptions = inputOptions.checkBoxOptions.map(x => { return (x.id === note.RelatedId && note.Text) ? { id: x.id, value: x.value, selected: true, icon: x.icon } : x });
                if (inputOptions?.commentsBox?.id === note.RelatedId && note.Text &&  inputOptions?.commentsBox?.value) {
                  inputOptions.commentsBox.value = note.Text;
                }
              });
            }
            notesData.push(inputOptions);
          }
        }
      });
    }
    return notesData;
  }

  resetNotes() {
    this.notesOptions.forEach(note => {
      if (note.checkBoxOptions && note.checkBoxOptions?.length) {
        note.checkBoxOptions = note.checkBoxOptions.map(x => { return { id: x.id, value: x.value, selected: false, icon: x.icon } });
      }
      if (note.commentsBox) {
        note.commentsBox.value = '';
      }
    });
  }

  getCategoryPreferencesNotes(noteType: NoteType, notesData) {
    let notes = [];
    notes = notes.concat(this.getNotes());
    if (notesData && notesData.length > 0) {
      notesData.forEach(eachNotes => {
        let existingCheckboxId;
        let existingCommentboxId;
        eachNotes.checkBoxOptions?.forEach(eachCheckbox => {
          if (this.activityService.operation == operationType.edit) {
            let editNote = noteType == NoteType.guestNote ? this.activityService.editData?.Contact?.Notes : this.activityService.editData?.Notes;
            if (editNote) {
              existingCheckboxId = editNote.filter(x => x.RelatedId == eachCheckbox.id)[0];
              existingCommentboxId = editNote.filter(x => x.RelatedId == eachNotes?.commentsBox?.id)[0];
            }
          }
          if (eachCheckbox.selected) {
            notes.push({
              RelatedId: eachCheckbox.id,
              Text: eachCheckbox.value,
              Id: existingCheckboxId && existingCheckboxId.Id ? existingCheckboxId.Id : null,
              Icon: eachCheckbox.icon,
              Type: noteType == NoteType.partyNote ? PartyNoteType.PredefinedNote : null
            });
          }
        });
        if (eachNotes?.commentsBox?.id && eachNotes?.commentsBox?.value) {
          notes.push({
            RelatedId: eachNotes.commentsBox.id,
            Text: eachNotes.commentsBox.value,
            Id: existingCommentboxId && existingCommentboxId.Id ? existingCommentboxId.Id : null,
            Type: noteType == NoteType.partyNote ? PartyNoteType.FreeFormNote : null
          });
        }
      });
    }
    return notes;
  }

  getNotes() {
    const notes = [];
    // Map Promocode Value
    if (this.promoCodeDetail) {
      const promoCode = { Type: 3, Text: this.promoCodeDetail };
      notes.push(promoCode);
    }
    return notes;
  }
  backToSlotSelect() {
    this.activityService.showGuestFields = false;
  }
  navigateGuestData() {
    if(this.activityService.isNonDining && !this.durationList.find(durationOption => durationOption.value === this.durationControl.value)){
      this.activityService.
      openSnackBar(this.ts.instant('Select valid duration'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      return;
    }
    let cartList = this.activityService.getSessionData('CartList_' + this.activityService.restaurantMerchantCode, true);
    let guestContact;
    if (this.activityService.editData?.Contact) {
      guestContact = this.activityService.editData?.Contact;
      let notes = this.noteType == NoteType.partyNote ? this.activityService.editData.Notes : this.activityService.editData.Contact.Notes;
      this.notesOptions = this.addCategoryPreferencesNotes(this.noteType, notes);
      guestContact.SecondaryContacts = this.activityService.editData?.BookingContacts?.length ? this.activityService.editData?.BookingContacts : [];
    } else {
      if (cartList && cartList.length) {
        guestContact = cartList.filter((cart) => cart.PropertyId == this.selectedActivityData?.RestaurantId)[0]?.Contact;
        guestContact = guestContact ? guestContact : cartList[0].Contact;
        let notes = this.noteType == NoteType.partyNote ? cartList[0].Notes : guestContact.Notes;
        this.notesOptions = this.addCategoryPreferencesNotes(this.noteType, notes);
        guestContact.SecondaryContacts = cartList[0].SecondaryContacts;
      }
    }
    if (guestContact?.SecondaryContacts?.length) {
      guestContact?.SecondaryContacts?.forEach(contact => {
        contact.Notes = this.addCategoryPreferencesNotes(this.noteType, contact.Notes, true);
      });
    }
    if(!guestContact && sessionStorage.getItem('guest_contact')){
      guestContact = JSON.parse(sessionStorage.getItem('guest_contact'));
    }
    this.editContactData = guestContact;
    this.activityService.startLoader();
    this.activityService.selectedSize = this.overAllBookingSize;
    let restaurantId = this.activityService.isDining ? this.activityService.selectedDining.RestaurantId
      : this.activityService.isNonDining ? this.activityService.selectedNonDining.RestaurantId : this.activityService.selectedActivities.RestaurantId;
    if (restaurantId) {
      this.activityService.GetCustomFields(restaurantId).subscribe(data => {
        this.customGuestFields = data.CustomGuestField
        if (!this.activityService.countriesList || !this.activityService.countriesList?.length) {
          this.getCountries();
        } else {
          this.activityService.showGuestFields = true;
          // if(this.activityService.isNonDining) this.getOpenBookingAddOns();
          this.activityService.stopLoader();
        }
      })
    }
  }
  getCountries() {
    this.activityService.GetCountries().subscribe(data => {
      if (data) {
        this.activityService.countriesList = data;
        this.activityService.showGuestFields = true;
        this.dfs.countriesList = data;
        // if(this.activityService.isNonDining) this.getOpenBookingAddOns();
        this.activityService.stopLoader();
      }
    });
  }
  setGuestData(data) {
    if (data && data.guestContact) {
      this.guestContactValidation = data.formValid;
      this.guestContact = data.guestContact;
      this.promoCodeDetail = data.guestContact.promoCode;
      this.finishReservationClicked = false;
    }
    if (data?.secondaryContact?.length) {
      for (let contacts of data?.secondaryContact) {
        if (contacts.isValid && data.formValid) {
          this.guestContactValidation = true;
        }
        else {
          this.guestContactValidation = false;
          break;
        }
      }
      if (this.guestContactValidation && data.secondaryContact?.length) {
        this.guestContact.SecondaryContactsList = data.secondaryContact;
      }
      if(this.activityService?.editData?.BookingContacts){
        this.activityService.editData.BookingContacts = _.cloneDeep(this.guestContact.SecondaryContactsList)
      }
    }
  }


  // Non Dining
  changeNonDiningDate(nextOrPrev: string) {
    this.currentFromDate = new Date(this.currentFromDate);
    if (nextOrPrev === 'next' && this.currentFromDate < new Date(this.nonDiningMaxDate)) {
      this.currentFromDate = new Date(this.currentFromDate.setDate(this.currentFromDate.getDate() + 1));
      this.currentFromDate = this.findNextAvailableDate(this.selectedActivityData, this.currentFromDate, true);
      if (this.activityService.operation === operationType.edit) this.updateNonDiningSlotTime();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    }
    else if (nextOrPrev === 'prev' && this.currentFromDate > this.activityService.currentDateTime.setHours(0, 0, 0, 0)) {
      this.currentFromDate = new Date(this.currentFromDate.setDate(this.currentFromDate.getDate() - 1));
      this.currentFromDate = this.findNextAvailableDate(this.selectedActivityData, this.currentFromDate, false);
      if (this.activityService.operation === operationType.edit) this.updateNonDiningSlotTime();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    }
  }

  changeNonDiningBookingTypeSize(nextOrPrev: string, index: number) {
    if (nextOrPrev === 'next' && this.bookingTypes[index].value < this.maxSizeAllowed) {
      this.bookingTypes[index].value = this.bookingTypes[index].value + 1;
      if (this.currentBookingSize > 0) this.updateSlotReloadValue();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    } else if (nextOrPrev === 'prev' && this.bookingTypes[index].value > 0) {
      this.bookingTypes[index].value = this.bookingTypes[index].value - 1;
      if (this.currentBookingSize > 0) this.updateSlotReloadValue();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    }
  }

  changeNonDiningCoverTypeSize(nextOrPrev: string, index: number) {
    if (nextOrPrev === 'next' && this.coverTypes[index].value < this.maxSizeAllowed) {
      this.coverTypes[index].value = this.coverTypes[index].value + 1;
      if (this.currentBookingSize > 0) this.updateSlotReloadValue();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    } else if (nextOrPrev === 'prev' && this.coverTypes[index].value > 0) {
      this.coverTypes[index].value = this.coverTypes[index].value - 1;
      if (this.currentBookingSize > 0) this.updateSlotReloadValue();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    }
  }

  changeNonDiningPartySize(nextOrPrev: string) {
    if (nextOrPrev === 'next' && this.currentBookingSize < this.maxSizeAllowed) {
      this.currentBookingSize = this.currentBookingSize + 1;
      if (this.currentBookingSize > 0) this.updateSlotReloadValue();
      this.checkNonDiningSessionorSlotAvailability(false, true);
    } else if (nextOrPrev === 'prev' && this.currentBookingSize > 0) {
      this.currentBookingSize = this.currentBookingSize - 1;
      this.checkNonDiningSessionorSlotAvailability(false, true);
      if (this.currentBookingSize > 0) this.updateSlotReloadValue();
    }
  }

  changeNonDiningTimeSlots(nextOrPrev: string) {
    if (nextOrPrev === 'next' && this.checkedNonDiningLocalTime !== this.selectedNonDiningSlots[this.selectedNonDiningSlots.length - 1]) { this.checkedNonDiningLocalTime = this.selectedNonDiningSlots[this.selectedNonDiningSlots.findIndex(slot => slot === this.checkedNonDiningLocalTime) + 1]; }
    else if (nextOrPrev === 'prev' && this.checkedNonDiningLocalTime !== this.selectedNonDiningSlots[0]) { this.checkedNonDiningLocalTime = this.selectedNonDiningSlots[this.selectedNonDiningSlots.findIndex(slot => slot === this.checkedNonDiningLocalTime) - 1]; }
  }

  checkNonDiningSessionorSlotAvailability(isIntial = false, filterChanges = false, retainSessionValue = true, isReload = false) {
    // this.setBookingData();
    if (this.activityService.sessionFilterValue && Object.keys(this.activityService.sessionFilterValue)?.length !== 0 && isIntial && retainSessionValue) {
      this.coverTypes = this.activityService.sessionFilterValue.coverTypes;
      this.bookingTypes = this.activityService.sessionFilterValue.bookingTypes;
      this.currentFromDate = new Date(this.activityService.sessionFilterValue.currentFromDate) || "";
      this.currentToDate = new Date(this.activityService.sessionFilterValue.currentToDate) || "";
      this.currentBookingSize = this.activityService.sessionFilterValue.currentBookingSize;
      this.sessionSlotsAvailableDates = this.activityService.sessionFilterValue.sessionSlotsAvailableDates;
      this.notesOptions = this.activityService.sessionFilterValue.notes;
      this.selectedSeatingArea = this.activityService.sessionFilterValue.selectedSeatingArea || 0;
      this.selectedSeatingType = this.activityService.sessionFilterValue.selectedSeatingType || 0;
      this.checkedNonDiningLocalTime = this.activityService.sessionFilterValue.checkedNonDiningLocalTime;
      this.marketingFlag = this.activityService.sessionFilterValue.marketingFlag;
      this.promoCodeDetail = this.activityService.sessionFilterValue.promoCodeDetail;
    } else if (this.activityService.fromConfirmation && isIntial && retainSessionValue) {
      this.coverTypes = this.activityService?.editData?.Covers?.filter(cover => cover.CoverTypeId)?.length > 0 ? _.uniqBy(this.activityService?.editData?.Covers?.map(cover => { return { id: cover.CoverTypeId, name: cover.CoverTypeName, value: cover.Covers }  }), 'id') : [];
      this.bookingTypes = this.activityService?.editData?.BookingTypeQuantities || this.activityService?.editData?.BookingTypes || this.bookingTypes;
      this.currentFromDate = this.activityService.isNonDining ? new Date(this.activityService?.editData?.ReservedFor) : new Date(this.activityService?.editData?.StartDate) || "";
      this.currentToDate = this.activityService.isNonDining ? new Date(this.activityService?.editData?.ReservedFor) : new Date(this.activityService?.editData?.EndDate) || "";
      this.currentBookingSize = this.activityService?.editData?.Size;
      this.checkedNonDiningLocalTime = this.activityService?.editData?.ReservedFor;
      this.selectedSeatingArea = this.activityService?.editData?.SeatingAreaId || 0;
      this.selectedSeatingType = this.activityService?.editData?.SeatingTypeId || 0;
      this.isCommunalTable = this.activityService?.editData?.IsCommunalTable;
      this.marketingFlag = this.activityService?.editData?.Contact?.MarketingOptedIn;
      this.selectedActivityData.CoverTypeQuantities = this.activityService?.editData?.CoverTypeQuantities;
      this.sessionSlotsAvailableDates = [];
      this.getBookingTypeValues();
      this.getCoverTypeValues();
    }
    this.isValidFormValues();
    if (this.validGroupSize && (!this.bShowLocation || isIntial || isReload || this.activityService.displayLocationType == LocationViewTypes.None)) {
      this.getavailableSlots(
        this.currentInstructors,
        this.currentLocations,
        this.currentFromDate,
        this.currentToDate,
        this.overAllBookingSize,
        isIntial,
        filterChanges
      );
    } else if (this.validGroupSize && this.bShowLocation && this.activityService.displayLocationType !== LocationViewTypes.None) {
      if (this.selectedNonDiningSlots.length) {
        this.getNonDiningLocationsApiHandler();
      }
    }
  }

  getSlotsForNonDining(reqObj, isInitial = false) {
    this.activityService.startLoader();
    this.subscriptions.add(this.activityService.GetRestaurantDateAvailability(
      this.selectedActivityData?.restaurantWidgetId || this.activityService.selectedNonDining?.RestaurantId || this.activityService?.selectedActivities?.RestaurantId,
      reqObj.BookingSize,
      this.isCommunalTable,
      true,
      moment(this.currentFromDate || this.activityService.currentDateTime).format('YYYY-MM-DD'),
      this.selectedSeatingArea ? this.selectedSeatingArea : null,
      this.activityService.operation === operationType.edit ? this.activityService?.editData?.Id : null,
      this.showSpecialEvent && +this.selectedActivityData?.SpecialMealId ? +this.selectedActivityData?.SpecialMealId : null,
      this.selectedSeatingType ? this.selectedSeatingType : null
    ).subscribe(data => {
      this.getSlotInitial = false;
      this.activityService.stopLoader();
      this.showAvailableDates = true;
      this.activityService?.selectedNonDining?.MealTabs.forEach(tab => { tab.selected = false });
      this.selectedNonDiningSlots = data;
      // && this.isTimeDropList
      if (isInitial && this.activityService.operation === operationType.create && this.activityService.displayLocationType !== LocationViewTypes.None) {
        this.checkedItem = true;
        this.checkedNonDiningLocalTime = this.selectedNonDiningSlots[0];
        this.matchedContinousSlots = [this.checkedNonDiningLocalTime];
      }
      this.originalTimeSlotList = data;
      this.bUpdateNonDiningBackUpData = true;
      this.nonDiningBackUpData = null;

      if (this.isEdit && this.activityService.editData?.ReservedFor) {
        this.checkedItem = data && data.findIndex(time => time === this.activityService.editData?.ReservedFor) !== 1 ? true : false;
        this.checkedNonDiningLocalTime = this.activityService.editData?.ReservedFor;
        this.durationControl.setValue((new Date(this.activityService.editData?.DepartureTime).getTime() - new Date(this.checkedNonDiningLocalTime).getTime()) / 60000);
        this.selectContinousSlots('', false);
      } else if (isInitial && this.activityService.sessionFilterValue?.checkedNonDiningLocalTime) {
        this.checkedItem = data && data.findIndex(time => time === this.activityService.sessionFilterValue.checkedNonDiningLocalTime) !== 1 ? true : false;
      }

      if (isInitial && this.activityService.displayLocationType !== LocationViewTypes.None) {
        if (this.selectedNonDiningSlots[0]) {
          this.getNonDiningLocationsApiHandler(isInitial);
        }
        this.setSelectedNonDiningSlotsDisplayText();
      } else if (this.bIsSlotReloadRequired || (!isInitial && this.activityService.displayLocationType !== LocationViewTypes.None)) {
        this.setSelectedNonDiningSlots(true, true);
      } else if(this.activityService.displayLocationType === LocationViewTypes.None){
        this.updateRateplanForSeatingType();
      }

      this.showOtherDaysAvailable();
      if (this.selectedNonDiningSlots.length) this.bIsSlotReloadRequired = false;
      else this.activityService.selectedNonDiningLocation = [];
    }, error => {
      this.getSlotInitial = false;
    })
    );
  }

  nonDiningSlotChangeListners(event) {
    this.setNonDiningBackUpData();
    if (this.checkedNonDiningLocalTime !== event || !this.bShowLocation || this.activityService.displayLocationType == LocationViewTypes.None) {
      this.checkedNonDiningLocalTime = (!this.isTimeDropList && this.checkedNonDiningLocalTime === event) ? '' : event;
      this.checkedItem = this.checkedNonDiningLocalTime === '' ? false : true;
      this.matchedContinousSlots = this.checkedItem ? [this.checkedNonDiningLocalTime] : [];
      this.selectContinousSlots('', true, true);
    } else {
      this.selectContinousSlots();
    }
    this.updateRateplanForSeatingType();
  }

  setSelectedNonDiningSlots(closePopover = true, isLocationReload?: boolean) {
    const matchedSlot = this.selectedNonDiningSlots.find(x => moment(x).format('hh:mm A') == moment(this.checkedNonDiningLocalTime).format('hh:mm A'));
    if (matchedSlot) {
      this.checkedNonDiningLocalTime = matchedSlot;
      this.selectContinousSlots('', closePopover, isLocationReload);
    } else {
      this.matchedContinousSlots = [];
      this.activityService.selectedNonDiningLocation = [];
      this.checkedItem = false;
      this.setSelectedNonDiningSlotsDisplayText();
    }
  }

  displayFn(user: any) {
    return user && typeof user == 'object' ? user.value : user;
  }

  private _filter(value: string): any[] {
    return this.durationList.filter(option => String(option.value).includes(value));
  }

  generateDurationList() {
    this.durationList = Array.from({ length: 5 }, (_, i) => {
      return { value: ((i + 1) * this.TimeSlotUnitInMinutes), displayName: `${((i + 1) * this.TimeSlotUnitInMinutes)} Min(s)` };
    });
  }

  changeNonDiningDuration(nextOrPrev: string) {

    this.setNonDiningBackUpData();

    if (nextOrPrev === 'next' && (Number(this.durationControl.value) + this.TimeSlotUnitInMinutes) <= this.durationList[this.durationList.length - 1].value)
      this.durationControl.setValue(Number(this.durationControl.value) + this.TimeSlotUnitInMinutes);
    else if (nextOrPrev === 'prev' && (Number(this.durationControl.value) - this.TimeSlotUnitInMinutes) >= this.TimeSlotUnitInMinutes)
      this.durationControl.setValue(Number(this.durationControl.value) - this.TimeSlotUnitInMinutes);

    if (this.activityService.displayLocationType == LocationViewTypes.None) {
      this.selectContinousSlots(nextOrPrev);
      this.updateRateplanForSeatingType();
    }
  }

  updateRateplanForSeatingType(){
    if(this.selectedSeatingType &&  this.matchedContinousSlots?.length){
      this.rateplanSupportService.getRateplanData(this.activityService.selectedNonDiningLocation[0], this.currentFromDate, this.matchedContinousSlots, this.durationControl.value, this.sizeMapping, +this.route.snapshot.params.restaurantId, this.selectedSeatingType, () => {
        
      });
    }else if(!this.matchedContinousSlots?.length){
      this.rateplanSupportService.seatingTypePriceDetail = {}
    }
  }

  selectContinousSlots(nextOrPrev?: string, closePopover = true, isLocationReload?: boolean) {
    if (this.checkedItem
      && ((this.durationControl.value >= this.TimeSlotUnitInMinutes
        || (this.durationControl.value == this.TimeSlotUnitInMinutes && nextOrPrev == 'prev'))
        && this.durationControl.value <= this.durationList[this.durationList.length - 1].value)) {

      const selectedSlotIndex = this.selectedNonDiningSlots.findIndex(x => x == this.checkedNonDiningLocalTime);
      if (selectedSlotIndex > -1) {

        const selectedDurationIndex = this.durationList.findIndex(x => x.value == this.durationControl.value);
        const matchedContinousSlots = this.selectedNonDiningSlots.slice(selectedSlotIndex, (selectedSlotIndex + selectedDurationIndex + 1));

        if (selectedDurationIndex != (matchedContinousSlots.length - 1)) {
          this.matchedContinousSlots = [];
          this.showContinousSlotErrorMsg();
          return;
        }

        let tempDate = moment(matchedContinousSlots[0]).toDate();
        for (let index = 0; index < matchedContinousSlots.length; index++) {
          const slot = matchedContinousSlots[index];
          tempDate = moment(tempDate).add(index != 0 ? this.TimeSlotUnitInMinutes : 0, 'm').toDate()
          if (new Date(moment(slot).toDate()).getTime() != new Date(tempDate).getTime()) {
            this.matchedContinousSlots = [];
            this.showContinousSlotErrorMsg();
            // this.bShowLocation = false;            
            return;
          }
        }

        this.matchedContinousSlots = matchedContinousSlots;
      }
    }
    this.setSelectedNonDiningSlotsDisplayText();
    if (!nextOrPrev && this.matchedContinousSlots.length && closePopover) this.closeSlotEditPopOver(true);
    if (this.matchedContinousSlots.length && isLocationReload) this.isValidFormValues(isLocationReload);
  }

  showContinousSlotErrorMsg() {
    this.activityService.
      openSnackBar(this.ts.instant('SlotsNotAvailableForGivenDuration'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
    // if (!this.bShowLocation) {
    // this.matchedContinousSlots = this.matchedContinousSlots.filter(x => x !== this.checkedNonDiningLocalTime);
    this.checkedItem = false;
    if (!this.matchedContinousSlots.length) this.checkedNonDiningLocalTime = null;
    // this.selectedNonDiningSlotsDisplayText = null;
    // this.tableList = [];
    // }
    // this.durationControl.setValue(this.TimeSlotUnitInMinutes);       
    // this.closeSlotEditPopOver();
  }

  setSelectedNonDiningSlotsDisplayText() {
    if (this.matchedContinousSlots[0]) {
      let localMoment = moment(this.matchedContinousSlots[0]);
      ;
      this.selectedNonDiningSlotsDisplayText = localMoment.locale(sessionStorage.getItem('languageCode') || DEFAULT_LANGUAGE_CODE).format('LT');
      if (this.matchedContinousSlots.length) {
      let localMoment = moment(this.matchedContinousSlots[this.matchedContinousSlots.length - 1]).add(this.TimeSlotUnitInMinutes, 'm');
        this.selectedNonDiningSlotsDisplayText += ` - ${localMoment.locale(sessionStorage.getItem('languageCode') || DEFAULT_LANGUAGE_CODE).format('LT')}`
      }
    } else {
      this.selectedNonDiningSlotsDisplayText = this.ts.instant('SelectSlot');
    }
  }

  setDurationControlValue(selectedDurationOption: any) {
    this.durationControl?.setValue(selectedDurationOption.value);
    this.selectContinousSlots();
  }

  highlightSelectedNonDiningSlots(slot: any) {
    return this.matchedContinousSlots?.filter(x => x == slot).length > 0;
  }

  showHideLocationEventHandler() {
    this.bShowLocation = !this.bShowLocation;
    if (this.bShowLocation) this.getNonDiningLocationsApiHandler();
  }

  getNonDiningLocationsApiHandler(isInitial?: boolean , isReload : boolean = false) {

    this.activityService.startLoader();

    this.activityService.selectedNonDiningLocation = [];
    this.tableList = [];
    this.activityService.nonDiningTotalSeatsSelected = 0;
    this.floorPlan = null;
    this.coverAndBookingTypeEditngPopOver?.close();

    if (this.activityService.displayLocationType == LocationViewTypes.LayoutView)
      this.activityService.getRestaurantImages(this.activityService.selectedNonDining.RestaurantId);

    const reqObj = this.buildNonDiningLocationApiRequest();
    this.subscriptions.add(this.rs.getOpenBookingLayoutData(reqObj).subscribe(response => {
      this.floorPlan = response.Payload.FloorPlans[0];
      this.activityService.stopLoader();
      this.tableList = response.Payload.FloorPlans[0]?.StandaloneTables.filter(x => x.IsAvailableForReservations && x.IsAvailableForBooking);
      let MappedSeatingTypes = [];
      this.tableList.forEach(x => {
        if (MappedSeatingTypes.findIndex(seatingTypeId => seatingTypeId == x.SeatingTypeId) < 0) {
          MappedSeatingTypes.push(x.SeatingTypeId);
        }
        x.seatingTypeColor = this.seatingType.find(y => y.id == x.SeatingTypeId)?.color || null;
        return x;
      })
      this.locationMappedSeatingTypes = MappedSeatingTypes;
      this.filteredTableList = JSON.parse(JSON.stringify(this.tableList));
      this.filterLocationList(this.selectedSeatingType, false);
      if (this.isEdit && isInitial) this.setSelectedLocations();
      if (!this.filteredTableList?.length && !isReload) {
        this.activityService.
          openSnackBar(this.ts.instant('LocationsNotAvailableForSelectedSlot'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
        // this.bShowLocation = false;
      }
    }));
  }

  buildNonDiningLocationApiRequest() {

    let selectedDate = moment(this.currentFromDate).format('YYYY-MM-DD');
    let startTime = moment(this.matchedContinousSlots[0]).format('HH:mm');

    return {
      RestaurantId: this.activityService.selectedNonDining.RestaurantId,
      TimeSlot: moment(`${selectedDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ss'),
      Duration: this.durationControl.value,
      PartySize: this.overAllBookingSize,
      CoverTypes: this.sizeMapping ? this.sizeMapping.sizes : this.getCoverTypeValues() ,
      BookingTypes: [],
      ReservationIdToIgnore: this.activityService.editData?.Id
    };
  }

  locationSelectionInMapHandler(locationCanvasObj) {
    let location = this.tableList.find(({ Id }) => Id === locationCanvasObj.Id);
    if (location) {      
      location.PriceDetail = locationCanvasObj.PriceDetail;
      this.locationSelectionEventHandler(location);
    }
  }

  locationViewSelectionEventHandler(location){
    this.rateplanSupportService.getRateplanData(location, this.currentFromDate, this.matchedContinousSlots, this.durationControl.value, this.sizeMapping, +this.route.snapshot.params.restaurantId, null, () => this.locationSelectionEventHandler(location));
  }

  locationSelectionEventHandler(location: any) {
  
    if (location) {
      if (location.SeatingAreaId != this.selectedSeatingArea) {
        this.selectedSeatingArea = null;
      }
      if (location.SeatingTypeId != this.selectedSeatingType) {
        this.selectedSeatingType = null;
      }
    }

    if (this.activityService.bEnableLocationMultiSelect) {

      let remainingAllowedPartySize: number = 0;
      if (location.isSelected) {
        location.isSelected = false;
      } else {
        this.activityService.nonDiningTotalSeatsSelected = 0;
        this.activityService.selectedNonDiningLocation.forEach(x => {
          this.activityService.nonDiningTotalSeatsSelected += x.selectedSeats;
        });

        if (this.activityService.nonDiningTotalSeatsSelected >= this.overAllBookingSize) {
          const removedFirstSelectedLocation = this.activityService.selectedNonDiningLocation.splice(0, 1);
          const removedLocationIndex = this.tableList.findIndex(x => x.Id == removedFirstSelectedLocation[0].Id);
          this.tableList[removedLocationIndex].isSelected = false;
          this.activityService.nonDiningTotalSeatsSelected -= removedFirstSelectedLocation[0].selectedSeats;
          // return this.activityService.
          // openSnackBar(this.ts.instant('MaxPartySizeReached'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
        }

        remainingAllowedPartySize = this.overAllBookingSize - this.activityService.nonDiningTotalSeatsSelected;

        if (location.MinPartySize <= remainingAllowedPartySize && !location.isSelected)
          location.isSelected = true;
        else if (!location.isSelected)
          this.activityService.
            openSnackBar(this.ts.instant('PartySizeMisMatch'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      }

      const macthedIndex = this.activityService.selectedNonDiningLocation.findIndex(x => x.Id == location.Id);
      if (macthedIndex < 0 && location.isSelected) {
        location.selectedSeats = remainingAllowedPartySize <= location.MaxPartySize ? remainingAllowedPartySize : location.MaxPartySize;
        this.activityService.selectedNonDiningLocation.push(location);
        this.activityService.nonDiningTotalSeatsSelected += location.selectedSeats;
      } else if (macthedIndex > -1 && !location.isSelected) {
        this.activityService.nonDiningTotalSeatsSelected -= location.selectedSeats;
        if (this.activityService.selectedNonDiningLocation.length > 1) this.activityService.selectedNonDiningLocation.splice(macthedIndex, 1);
        else this.activityService.selectedNonDiningLocation = [];
      }

    } else if (!this.activityService.bEnableLocationMultiSelect) {

      if (((location.MinPartySize <= this.overAllBookingSize && location.MaxPartySize >= this.overAllBookingSize) || !this.activityService.validateLocationSize)
        && !location.isSelected)
        location.isSelected = true;
      else if (!location.isSelected)
        this.activityService.
          openSnackBar(this.ts.instant('PartySizeMisMatch'), this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime);
      else location.isSelected = false;

      const macthedIndex = this.activityService.selectedNonDiningLocation.findIndex(x => x.Id == location.Id);
      if (macthedIndex < 0 && location.isSelected) {
        location.selectedSeats = this.overAllBookingSize;
        this.activityService.selectedNonDiningLocation = [location];
        this.activityService.nonDiningTotalSeatsSelected = location.selectedSeats;
        this.tableList.forEach(x => {
          if (x.Id != location.Id) {
            x.isSelected = false;
            x.selectedSeats = 0;
          }
          return x;
        })
      } else if (macthedIndex > -1 && !location.isSelected) {
        this.activityService.nonDiningTotalSeatsSelected = 0;
        this.activityService.selectedNonDiningLocation = [];
      }
    }


    // if(this.activityService.nonDiningTotalSeatsSelected >= this.currentBookingSize){
    this.filterLocationList(this.selectedSeatingType, false);
    // }

    // if (this.activityService.selectedNonDiningLocation != location) this.activityService.selectedNonDiningLocation = location;
    // else this.activityService.selectedNonDiningLocation = null;

    // const macthedIndex = this.tableList.findIndex(x => x.Id == location.Id);
    // if(macthedIndex > -1){
    //   this.tableList[macthedIndex].isSelected = !this.tableList[macthedIndex].isSelected;
    // }

    this.updateIndicator = (new Date()).getTime();

  }

  editNonDiningSelectedSlots() {
    this.bShowLocation = false;
    this.tableList = [];
  }

  seatingArea_TypeFieldChangeHandler(seatType: any, valueUpdate = true, isSlotReloadRequired = false) {
    if ((seatType || seatType == null) && !valueUpdate) {
      this.loadSeatingTypes(seatType);
      this.selectedSeatingType = null;
    }
    if (valueUpdate) this.selectedSeatingType = this.selectedSeatingType != seatType.id ? seatType.id : null;
    if (this.activityService.displayLocationType !== LocationViewTypes.None)
      this.filterLocationList(seatType, false, isSlotReloadRequired);
    else
      this.checkNonDiningSessionorSlotAvailability(false, true);
  }

  filterLocationList(seatType: any, valueUpdate = true, isSlotReloadRequired = false) {
    if (valueUpdate) this.selectedSeatingType = this.selectedSeatingType != seatType.id ? seatType.id : null;
    if (isSlotReloadRequired) this.bIsSlotReloadRequired = true;
    if (this.selectedSeatingType || this.selectedSeatingArea)
      this.filteredTableList = this.tableList.filter(x => {
        return (this.selectedSeatingArea && x.SeatingAreaId == this.selectedSeatingArea) || (!this.selectedSeatingArea || !this.activityService.displaySeatingArea);
      }).filter(y => { return (this.selectedSeatingType && y.SeatingTypeId == this.selectedSeatingType) || (!this.selectedSeatingType || !this.activityService.displaySeatingType) });
    else
      this.filteredTableList = this.tableList;
  }

  setGuestAndCoverTypes(data, retainSessionValue) {
    this.selectedActivityData = data;
    // this.setNoteType();
    this.isSessionClass = this.selectedActivityData?.ClassType === ClassType.Session;
    this.minSizeAllowed = 1;
    this.coverTypes = data?.GuestTypes?.filter(guest => guest.IsRegularReservation).map(type => {
      return {
        id: type.Id,
        name: type.Name,
        value: 0
      };
    });
    this.activityHeadlines = data.ActivityAttributes;
    if (this.coverTypes?.length && !this.activityService.isNonDining) {
      this.coverTypes[0].value = 1;
    }

    this.bookingTypes = data?.BookingTypes?.map(type => {
      return {
        id: type.Id,
        name: type.Name,
        value: 0
      };
    });

    if (this.bookingTypes?.length && !this.activityService.isNonDining) {
      this.bookingTypes[0].value = 1;
    }

    this.calculatePartySize();

    // this.instructorList = this.getInstructor(data.StaffValues);
    // this.locationList = this.getLocations(data.LocationId);
    this.isMultiSlotSelection = data.EnableMultiSlotSelection;
    // this.venueAllocationMappings = data.AllocationTypes;
    this.showSessionorSlots = false;
    this.selectedClassSchedule = [];
    this.sessionSlotsAvailableDates = [];


    this.overAllBookingSize = this.minSizeAllowed;
    if (this.bookingTypes?.length) {
      this.bookingTypes[0].value = this.minSizeAllowed;
    }
    if (this.coverTypes?.length) {
      this.coverTypes[0].value = this.minSizeAllowed;
    }
    if (!this.coverTypes?.length && !this.bookingTypes?.length) {
      this.currentBookingSize = this.minSizeAllowed;
    }

    this.checkNonDiningSessionorSlotAvailability(true, false, retainSessionValue);

  }

  getOpenBookingSlots() {
    return [{ LocalTime: this.updateNonDiningSlotTime(), DurationInMinutes: this.durationControl.value, Duration: this.durationControl.value }];
  }

  closeSlotEditPopOver(clearBackUpData?: boolean) {
    if (this.activityService.displayLocationType == LocationViewTypes.None) return;
    this.slotEditngbPopOver?.close();
    if (clearBackUpData || (this.nonDiningBackUpData && !this.matchedContinousSlots.length))
      this.clearNonDiningBackUpData();
  }

  clearNonDiningBackUpData(updateValue?: boolean) {
    if (this.nonDiningBackUpData && !this.matchedContinousSlots.length) {
      this.durationControl.setValue(this.nonDiningBackUpData.duration);
      this.matchedContinousSlots = this.nonDiningBackUpData.slots;
      this.setSelectedNonDiningSlotsDisplayText();
    }
    this.nonDiningBackUpData = null;
    this.bUpdateNonDiningBackUpData = true;
  }

  setNonDiningBackUpData() {
    if (this.activityService.displayLocationType == LocationViewTypes.None) return;
    if (this.bUpdateNonDiningBackUpData) {
      this.bUpdateNonDiningBackUpData = false;
      this.nonDiningBackUpData = {
        duration: this.durationControl.value,
        slots: this.matchedContinousSlots
      };

      this.matchedContinousSlots = [];
      this.checkedItem = false;
      this.checkedNonDiningLocalTime = '';
    }
  }

  closeTypeEditPopOver() {
    this.coverAndBookingTypeEditngPopOver.close();
  }

  checkSlotReloadRequired() {
    if (this.bIsSlotReloadRequired) this.checkNonDiningSessionorSlotAvailability(false, true, true, true);
  }

  setSelectedLocations() {
    let location;
    this.activityService.editData?.TableIds?.forEach(x => {
      location = this.filteredTableList.find(({ Id }) => Id === x);
      if (location) {
        this.locationSelectionEventHandler(location);
      }
    });
    this.rateplanSupportService.getRateplanData(location, this.currentFromDate, this.matchedContinousSlots, this.durationControl.value, this.sizeMapping, +this.route.snapshot.params.restaurantId, null, () => {});
  }

  updateSlotReloadValue() {
    this.bIsSlotReloadRequired = true;
  }

  updateNonDiningSlotTime() {
    let selectedDate = moment(this.currentFromDate).format('YYYY-MM-DD');
    let startTime = moment(this.matchedContinousSlots[0]).format('HH:mm');

    return this.checkedNonDiningLocalTime = moment(`${selectedDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ss');
  }

  getOpenBookingSelectedSeatingArea() {
    if (this.activityService.displayLocationType !== LocationViewTypes.None) {
      return this.selectedSeatingArea = this.activityService.selectedNonDiningLocation[0]?.SeatingAreaId || null;
    }
    return this.selectedSeatingArea;
  }

  getOpenBookingSelectedSeatingType() {
    if (this.activityService.displayLocationType !== LocationViewTypes.None) {
      return this.selectedSeatingType = this.activityService.selectedNonDiningLocation[0]?.SeatingTypeId || null;
    }
    return this.selectedSeatingType;
  }

  getCoverTypesReservation() : void {
    this.coverTypes = this.activityService.selectedDining.GuestTypes?.filter(x => x.IsRegularReservation) || [];
  }

  bookingSizeChange() {
    if(this.route.snapshot.queryParams.activityId || this.route.snapshot.queryParams.bookaspot){
    this.currentBookingSize = this.getCoverTypesize();
    if(this.activityService.isNonDining && !this.getSlotInitial) {
      this.checkSessionorSlotAvailability(false, true)
    }
    if(!this.activityService.isDining && !this.activityService.isNonDining) {
      if(this.currentBookingSize > 0){ this.updateSlotReloadValue(); }
      if(!this.getSlotInitial)
      this.checkNonDiningSessionorSlotAvailability(false, true)
    }
    if(this.sizeMapping?.errors?.length) {
      this.activityService.openSnackBar(this.sizeMapping.errors[0], this.ts.instant('close'), this.activityService.ConfigSettings.snackBarTime, 'error-snackbar');
    }
    this.isValidFormValues();
  }
  }

  getCoverTypesize(): number {
    return this.sizeMapping?.sizes?.reduce((res, curr) => res + (+curr.Covers), 0);
  }

  // Non Dinning

  @HostListener('window:beforeunload') goToPage() {
    sessionStorage.setItem('isSessionComponentReload', 'true');
  }

}

interface DataItem {
  Id: number;
  value: string;
  isSelected: boolean;
  date: string; // Keep as string for input
}

function sortByDate(arr: any[]){
  return arr.sort((a, b) => {
      return new Date(a.date).getTime() - new Date(b.date).getTime();
  });
}


@Pipe({
  name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private sanitizer:DomSanitizer){}

  transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}


